(function (ws) {
    'use strict';

    ws.views.handsOnTable = ws.views.googleAnalytics.extend({

        TOPDOWN_PARENT_BUNDLE_TYPE: globals.bundles.TOPDOWN_PARENT_BUNDLE_TYPE,
        TOPDOWN_CHILD_BUNDLE_TYPE: globals.bundles.TOPDOWN_CHILD_BUNDLE_TYPE,
        ROLLUP_PARENT_BUNDLE_TYPE: globals.bundles.ROLLUP_PARENT_BUNDLE_TYPE,
        ROLLUP_CHILD_BUNDLE_TYPE: globals.bundles.ROLLUP_CHILD_BUNDLE_TYPE,
        STANDARD_TYPE: globals.bundles.STANDARD_TYPE,
        CISCO_PARENT_BUNDLE_TYPE: globals.bundles.CISCO_PARENT_TYPE,
        CISCO_CHILD_BUNDLE_TYPE: globals.bundles.CISCO_CHILD_TYPE,
        AVAYA_CLOULD_TYPE: globals.bundles.AVAYA_CLOUD_TYPE,
        CISCO_FULL_TERM_ITEM: globals.bundles.CISCO_FULL_TERM_ITEM,
        BLUE_SKY_TYPE: globals.bundles.BLUE_SKY_TYPE,
        BLUE_SKY_PARENT_TYPE: globals.bundles.BLUE_SKY_PARENT_TYPE,
        BLUE_SKY_CHILD_TYPE: globals.bundles.BLUE_SKY_CHILD_TYPE,
        CREDIT_TYPE: globals.bundles.CREDIT_TYPE,
        EXPANDED_TYPE: globals.bundles.EXPANDED_TYPE,
        CONSOLIDATED_TYPE: globals.bundles.CONSOLIDATED_TYPE,
        CELL_READ_ONLY_CLASS: 'read-only',
        TANGIBLE_PRODUCT_VALUE: 'TAN',
        errorCells: [],
        parentTopDownReadOnlyCells: globals.readonly.parentTopDownReadOnlyCells,
        parentChildTopDownReadOnlyCells: globals.readonly.parentChildTopDownReadOnlyCells,
        tecexReadOnlyCells: globals.readonly.tecexReadOnlyCells,
        parentRollUpReadOnlyCells: globals.readonly.parentRollUpReadOnlyCells,
        parentChildRollUpReadOnlyCells: globals.readonly.parentChildRollUpReadOnlyCells,
        childTopDownReadOnlyCells: globals.readonly.childTopDownReadOnlyCells,
        childRollUpReadOnlyCells: globals.readonly.childRollUpReadOnlyCells,
        stdReadOnlyCells: globals.readonly.stdReadOnlyCells,
        supportLineParent: globals.readonly.supportLineParent,
        stdCrossCellsReadOnlyCells:globals.readonly.stdCrossCellsReadOnlyCells,
        ciscoReadOnlyCells: globals.readonly.ciscoReadOnlyCells,
        avayaChildReadOnlyCells: globals.readonly.avayaChildReadOnlyCells,
        avayaCloudReadOnlyCells: globals.readonly.avayaCloudReadOnlyCells,
        supportChildReadOnlyCells: globals.readonly.supportChildReadOnlyCells,
        configuratorChildReadOnlyCells: globals.readonly.configuratorChildReadOnlyCells,
        blueSkyReadOnlyCells: globals.readonly.blueSkyReadOnlyCells,

        // Currency
        currency: null,

        // Read Only Table
        readOnly: false,

        //default column values
        partNoColumn: 2,
        quantityColumn: 3,
        vendorDiscountColumn: 7,

        events: {
            'change .table-select-entryType': 'setEntryType',
            'click .qut-add-row': 'addRow',
            'click .qut-search-row': 'checkIfFilterAppliedBeforeAddNewProducts',
            'click .qut-delete-row': 'confirmDelete',
            'change .error': 'resetField',
            'click .comp-tooltip-label': 'openTooltip',
            'click .delAssociateProducts': 'removeWithMandatoryProducts',
            'click .delProducts': 'removeProducts',
            'click .qut-button-reset-columns': 'resetColumnOrder',
            'click .qut-button-showHide-columns': 'popShowHideColumnModal',
            'mouseover .refrenceErrtooltip': 'ediContractErrorTooltip',
            'click .grid-control': 'controlGridHandle',
            'click .exp-pg-btn': 'expandFullScreen'
        },

        /**
         * Initializes the view
         */
        initialize: function() {
            this.productSelectableTypes = [this.ROLLUP_PARENT_BUNDLE_TYPE, this.TOPDOWN_PARENT_BUNDLE_TYPE, this.STANDARD_TYPE, 'VIP', this.CISCO_PARENT_BUNDLE_TYPE, 'SCONTP', 'TECEX', this.AVAYA_CLOULD_TYPE, this.BLUE_SKY_PARENT_TYPE, this.BLUE_SKY_TYPE, this.CISCO_FULL_TERM_ITEM];
            this.productExpandableTypes = [this.ROLLUP_PARENT_BUNDLE_TYPE, this.TOPDOWN_PARENT_BUNDLE_TYPE, this.CISCO_PARENT_BUNDLE_TYPE, 'SCONTP', this.BLUE_SKY_PARENT_TYPE, this.CISCO_FULL_TERM_ITEM];
            this.productChildTypes = [this.ROLLUP_CHILD_BUNDLE_TYPE, this.TOPDOWN_CHILD_BUNDLE_TYPE, this.CISCO_CHILD_BUNDLE_TYPE, this.BLUE_SKY_CHILD_TYPE];
            this.markUpRollUpDisable = [this.ROLLUP_PARENT_BUNDLE_TYPE, this.TOPDOWN_PARENT_BUNDLE_TYPE];
            this.resellerDecimalPoints = parseInt($('#resellerDecimalPoints').val());
            this.createCustomEditors();
            this.isExecutedOnce = false;
            this.isVisibleRowCountOne = false;
            this.makeBulkUpdateApiCall = false;
            window.isCustomerLineNumberMandatory = false;
            this.getRowNoAndKey = {};
            this.isSumAvailable = false;
            this.filterUnMatchedRows = [];
            this.filteredColumnsDisplay = {};
            this.filterSearchObj = {};
            this.latestColClicked = '';
            this.selectedVrfHeader = '';
            this.columnsWithDecimals = [];
            this.hiddenColumnsArray = [];
            this.shouldShowConfiguratorArray = [];
            this.shouldShowConfiguratorColumn = true;
            this.appliedFiltersONfilterByValue = {};
            this.appliedFiltersONfilterByValueDisplay = {};
            this.uncheckedArrayForFilter = [];
            this.parentBundleTypes = ['RPB', 'VPSP', 'VPSC', 'SCONTP', 'SCONTC'];
            this.subscriptionTypes = ['SUBSCRIPTION', 'PER_UNIT_SUBSCRIPTION'];
            this.blueSkyTypes = ['CONFIGURABLE', 'CONFIGURED_PARENT', 'CONFIGURED_CHILD'];
            this.annuityTypesCheckbox = ['FULL_TERM_ITEM', 'FULL_TERM_ITEM_CHILD', 'FULL_TERM_ITEM_PARENT'];
            this.eventAgg.on('getSBASelectedRows', this.getSBASelectedRows, this);
            this.eventAgg.on('getSelectedRowsToApplySBAfromPricingGrid', this.getSelectedRowsToApplySBAfromPricingGrid, this);
            this.tableHeader = [];
            this.tableColumnOrder = [];
            this.tableColumnWidth = [];
            this.jsonTableData = [];
            this.colHeaderMapping = [];
            this.jsonTableMap = [];
            this.jsonTableIdMap = [];
            this.jsonTableBody = [];
            this.currentCellCoords = [];
            this.filterConditions = {};
            this.emptyHandsonObject = {};
            this.serviceEnforcementProductArray = {};
            this.productAvailabilityArray = {};
            this.partNumberName = '';
            this.quantityStockMap = [];
            this.defaultSlocLabel = '';
            this.manualUpdateGlobalPointData = [];
            this.bulkUpdateTargets = ['listPrice', 'purchaseDiscount', 'extendedCost', 'purchasePrice', 'marginPercentage', 'resellerPrice',
            'marginPercentage', 'resellerPercentage', 'listPrice', 'purchaseDiscount', 'purchasePrice', 'globalPoints', 'marginPercentage', 'resellerPrice',
            'resellerPercentage', 'cntrtStartDate', 'marginGPL', 'cntrtEndDate', 'wgIntrNote', 'notes', 'wgCustText', 'poText'];

            this.tooltipTargets = ['quantity', 'purchaseDiscount', 'resellerPrice', 'referenceNumber', 'listPrice', 'warehouseList', 'itemCategorySelected', 'custPartNum', 'extCustomerPartNumber', 'shipDate', 'sloc', 'wgCustText', 'billBlock', 'poText', 'cntrtEndDate', 'exceptionReason', 'wgIntrNote', 'cntrtStartDate', 'custLineNum', 'vendor', 'delBlock', 'delGroup', 'duration', 'extendedPrice', 'taxClass', 'durationUnit', 'inboundDuty', 'handlingUnitVAS', 'purchasePrice', 'extInternalOrderAttachment', 'extExternalOrderAttachment', 'margin', 'parentEntryNumber'];
            this.selectedRowIds = [];
            this.selectedVisualRows = [];
            $(document).on('mouseover', '.icon-information.tooltip-target', (e) => {
                this.renderAvailabilityHelpTooltip(e);
            });

            $(document).on('change', '.toggle-column-switch', (e) => {
                this.toggleColumnDisplay(e);
            });

            $(document).on('click', '.grid-control-modal .close-button', (e) => {
                this.renderAfterGridModalClose(e);
            });

            $(document).on('mouseover', '.highlight', (event) => {
                if ($('.dynamic-sum-display').html().length) {
                    $('.dynamic-sum-display').css({
                        left: event.pageX + 20 + 'px',
                        top: event.pageY - window.pageYOffset + 'px',
                        display: 'block'
                    });
                }
            });

            $(document).on('mouseout', '.highlight', (event) => {
                if ($('.dynamic-sum-display').css('display') === 'block') {
                    $('.dynamic-sum-display').css({
                        display: 'none'
                    });
                }
            });

            $('#pricingUpdateDate').pikaday({
                format: dateFormat,
                formatStrict: true,
                yearRange: [2000, 2500],
                /** onSelect callback */
                onSelect: function () {
                    $('.pricingUpdateDateChange').val(this.getMoment().format(dateFormat)).trigger('change');
                }
            });

            this.isPricingGridLoaded = false;
            if (isOrderEntrySite) {
                const gridCheck = setInterval(() => {
                    if (this.isPricingGridLoaded) {
                        this.onChangeOfEndUserBillingCheckbox();
                        if ($('.entrylineLevelOptions input:checkbox:checked').length > 0) {
                            this.callMismatchApi();
                        }

                        clearInterval(gridCheck);
                    }
                }, 1000);
            }
        },

        checkIfFieldsHasToBeDisabled: function () {
            if (isOrderEntrySite) {
                const disableCheck = setInterval(() => {
                    if (this.$quoteCartTable && this.$quoteCartTable !== null && this.$quoteCartTable.table !== null) {
                        if (!$('#endUserBilling').prop('readonly')) {
                            this.togglesReadOnlyColumnsBasedOnShipCompleteAndEndUser();
                        } else if ($('#endUserBilling').prop('readonly')) {
                            this.togglesReadOnlyColumnsBasedOnShipCompleteAndEndUser(true);
                        }

                        clearInterval(disableCheck);
                    }
                }, 1000);
            }
        },

        controlGridHandle: function () {
            this.eventAgg.trigger('gridControlModal');
        },

        renderAfterGridModalClose: function () {
            this.reRenderTable();
        },

        toggleColumnDisplay: function (e) {
            e.stopImmediatePropagation();
            let hidingColumnPlugin = this.$quoteCartTable.getPlugin('hiddenColumns');
            if ($(e.currentTarget).prop('checked')) {
                hidingColumnPlugin.showColumn(this.$quoteCartTable.propToCol($(e.currentTarget).data('name')));
            } else {
                hidingColumnPlugin.hideColumn(this.$quoteCartTable.propToCol($(e.currentTarget).data('name')));
            }
        },

        /**
         * Initializes table components after render
         */
        initializeComponents: function() {
            this.$masterContainer = this.$('.ht_master');
            this.$table = $(this.$('.ht_master').find('table'));
            this.$thead = this.$table.find('thead');
            this.$lastRow = this.$table[0].rows[this.$table[0].rows.length - 1];
            this.$htCloneTop = this.$('.ht_clone_top');
            this.$htCloneTopLeft = this.$('.ht_clone_top_left_corner');
            this.stickyHeight =  $('.qut-fixed-detail').height();
            this.$topScrollBar = this.$('.table-scroller');
            this.$bottomScrollBar = this.$('.comp-quote-detail-table > .ht_master .wtHolder, .comp-quote-vrf-table > .ht_master .wtHolder');
            this.maxRowsWithoutScroll = 0;
        },

        /**
         * Initializes table default variables
         */
        initializeTableVariables: function () {
            //global table vars
            this.colWidths = [];
            this.colHeaders = [];
            this.colMapping = [];
            this.colHeaderMapping = [];
            this.matchedMapping = [];
            this.errorCells = [];

            // variables to preserve styling on table re-render
            this.editedRow = null;
            this.editedCol = null;
            this.dropdownEditedRow = null;
            this.dropdownEditedCol = null;
            this.pendingRow = null;
            this.pendingCell = null;
            this.pending = false;
            this.selectedRows = [];
            this.contextVisible = false;
            this.pageYOffset = 0;
            this.partNoCol = 2;
        },

        /**
         * Build custom editors for HoT
         */
        createCustomEditors: function() {
            this.MaxLengthEditor = Handsontable.editors.TextEditor.prototype.extend();

            /**
             * Prepare the editor
             */
            this.MaxLengthEditor.prototype.prepare = function () {
                Handsontable.editors.TextEditor.prototype.prepare.apply(this, arguments);
                this.TEXTAREA.maxLength = this.cellProperties.maxLength;
            };

            Handsontable.editors.MaxLengthEditor = this.MaxLengthEditor;
            Handsontable.editors.registerEditor('maxLengthTextInput', this.MaxLengthEditor);
        },

        /**
         * Re render the table to fix possible misalignment in the table rows.
         */
        updateTableDimensions: function () {
            if (this.$quoteCartTable) {
                this.$quoteCartTable.render();
            }
        },

        /**
         * On Scroll: show/hide persistent table header
         */
        onScrollQuote: function () {
            this.pageYOffset = window.pageYOffset;
        },

        /**
         * Create JSON object for columns data
         */
        createTableJson: function () {
            _.each(this.$colHeaders.find('table thead tr th'), function (value, index) {
                this.columnsData.push({
                    id: index,
                    attr: $(value).data('attr'),
                    name: $(value).data('name'),
                    readOnly: $(value).data('readonly'),
                    wordWrap: $(value).data('wordwrap'),
                    checkbox: $(value).data('checkbox'),
                    render: $(value).data('render'),
                    autocomplete: $(value).data('autocomplete'),
                    type: $(value).data('type'),
                    format: $(value).data('format'),
                    tooltip: $(value).data('infotooltip'),
                    renderer: $(value).data('renderer'),
                    cssClass: $(value).data('cssclass'),
                    maxLength: $(value).data('maxlength'),
                    width: $(value).attr('width'),
                    innerhtml: $.trim($(value).html())
                });
            }.bind(this));
        },

        /**
         * Update currency format for Canada
         */
        updateCurrencyFormat: function () {
            let numeralsCurrentFormat = {
                delimiters: {
                    thousands: ',',
                    decimal: '.'
                },
                abbreviations: {
                    thousand: 'k',
                    million: 'm',
                    billion: 'b',
                    trillion: 't'
                },
                /**
                 * Ordinal function
                 * @param {number} number
                 * @returns {string}
                 */
                ordinal: function (number) {
                    /* jshint ignore:start */
                    let b = number % 10;
                    return (~~(number % 100 / 10) === 1) ? 'th' :
                        (b === 1) ? 'st' :
                            (b === 2) ? 'nd' :
                                (b === 3) ? 'rd' : 'th';
                    /* jshint ignore:end */
                },

                currency: {
                    symbol: this.currencySymbol
                }
            };

        },

        /**
         * Hide table errors
         */
        hideTableErrors: function () {
            this.$('.table-error').hide();
            this.$tableError.hide();
        },

        /**
         * Re-render table
         */
        renderTableHideErrors: function () {
            this.$quoteCartTable.render();
            this.hideErrors();
        },

        /**
         * Hide all error messages
         */
        hideErrors: function () {
            this.$('.error-message').not('.qut-product-table-error-cells, .freight-div-error-message').hide();
        },

        /**
         * Reset Table errors
         */
        resetErrors: function () {
            this.hasCriticalError = false;
            this.hideErrors();
            this.checkTableErrors();
        },

        /**
         * Render Table Tooltip
         * @returns {*}
         */
        renderTableTooltip: function () {
            return new ws.views.quoteTableTooltipPoScrap();
        },

        /**
         * Show availability tooltip in table header
         */
        renderAvailabilityHelpTooltip: function (e) {
            this.eventAgg.trigger('quoteTableTooltip', {
                follow: e.currentTarget,
                template: _.template($('#comp-table-tooltip-availability-help').html())
            });
        },

        /**
         * Reset field with error message
         * @param {Object} e
         */
        resetField: function (e) {
            let $el = $(e.currentTarget);
            $el.removeClass(this.errorClass);
            $el.nextAll(this.errorMsg).hide();
            $el.nextAll(this.customErrorMsg).hide();
        },

        /**
         * Save column order and width to BE
         */
        saveColumnSettings: function () {
            let columnSettings = [];
            let totalColumns = this.$quoteCartTable.countCols();
            for (let i = 0; i < totalColumns; i++) {
                columnSettings.push({
                    id: i,
                    name: this.$quoteCartTable.colToProp(i),
                    width: this.$quoteCartTable.getColWidth(i)
                });
            }

            this.columnsSettingsModel.set('columns', columnSettings);
            this.colMapping = columnSettings;
            this.columnsSettingsModel.save().done(function () {
                this.toggleResetButton(true);
                this.resizeContainer();
            }.bind(this)).fail(function () {
                console.log('error from api');
            }.bind(this));
        },

        /**
         * Triggers updateListPriceCost & shares updated model.
         * @param {{row: number, col: number, val: number, trigger: string}} updatedValue
         */
        getUpdatedModel: function (updatedValue) {
            this.updateListPriceAndPurchasePrice(updatedValue);
        },

        /**
         * Remove the focus from the table.
         */
        removeFocusFromTheTable: function () {
            this.$quoteCartTable.deselectCell();
        },

        /**
         * Re-index error cell rows when row spliced into table
         */
        updateErrorCellIndex: function () {
            let newCell;

            //reindex selected rows
            _.each(this.selectedRows, function(row) {
                this.selectedRows.splice(row, 1);
                this.selectedRows.push(row + 1);
            }.bind(this));

            //reindex error cells
            _.each(this.errorCells, function (cell) {
                newCell = {row: parseInt(cell.row) + 1, col: cell.col};
                this.errorCells.splice(this.errorCells.indexOf(cell));
                this.errorCells.push(newCell);
            }.bind(this));
        },

        /**
         * Check for any table errors that would prevent quote submission
         */
        checkTableErrors: function () {
            this.hideErrors();
            this.$quantityError.addClass('hide').hide();
            this.$invalidProductErrorMessage.addClass('hide').hide();
            this.$purchasePriceStockItemError.addClass('hide').hide();
            this.$itemCategoryMismatchError.addClass('hide').hide();
            let errors;
            let validPartNos = this.newjsonData.rows.filter(function (item) {
                return item.partNo.value !== undefined && item.partNo.value !== '';
            });

            let invalidQtys = _.where(this.errorCells, {col: this.$quoteCartTable.propToCol('quantity')}) || {};
            let invalidCntrtDate = _.where(this.errorCells, {col: this.$quoteCartTable.propToCol('cntrtStartDate')}) || {};
            invalidCntrtDate = _.where(this.errorCells, {col: this.$quoteCartTable.propToCol('cntrtEndDate')}) || {};
            let itemCategoryErrors = _.filter(this.newjsonData.rows, function (model) {
                return model.itemCategoryMismatch;
            });

            let itemCategoryErrorsPartNo = _.map(itemCategoryErrors, function (model) {
                return model.partNo.value;
            });

            errors = validPartNos.length === 0 || invalidQtys.length > 0 || invalidCntrtDate.length > 0;
            switch (true) {
                case (validPartNos.length === 0):
                    this.$requiredErrorMessage.removeClass('hide').show();
                    this.$tableError.addClass('hide');
                    break;
                case (this.hasCriticalError):
                    this.$purchasePriceStockItemError.removeClass('hide').show();
                    break;
                case (itemCategoryErrors.length > 0):
                    this.$itemCategoryMismatchError.removeClass('hide').show();
                    this.$itemCategoryMismatchError.find('.part-no-list').text(_.unique(itemCategoryErrorsPartNo).join(', '));
                    break;
                case (invalidQtys.length > 0):
                    this.$tableError.removeClass('hide').show();
                    this.$quantityError.removeClass('hide').show();
                    break;
            }

            this.eventAgg.trigger('showTableErrors', errors, this.hasCriticalError);
            this.$quoteCartTable.render();
        },

        deletePricingGridMatchedfieds: function () {
            if (this.matchedMapping.length) {
                let type = '';
                this.matchedMapping.map((item) => {
                    if (item.matchingFields) {
                        if (item.matchingFields.PO) {
                            type = item.matchingFields.PO;
                        } else if (item.matchingFields.EDI) {
                            type = item.matchingFields.EDI;
                        }
                    }

                    if (type) {
                        ['resellerPrice', 'extendedPrice'].forEach((field) => {
                            if (type.includes(field)) {
                                type.splice(type.indexOf(field), 1);
                            }
                        });
                    }
                });

                this.checkMisMatch();
            }
        },

        setMisMatch: function (matchedData, functionCallRequired) {
            this.matchedMapping = matchedData ? matchedData : [];
            if (functionCallRequired) {
                this.checkMisMatch();
            }
        },

        checkForPriceProtectionDate: function () {
            let error = false;
            _.each(this.newjsonData.rows, (model, index) => {
                if (model) {
                    if (moment(model.priceProtectionDate.value, dateFormat).isBefore(new Date(), 'date')) {
                        error = true;
                    }
                }
            });

            if (error) {
                $('.price-protection-warning').removeClass('hide');
            }
        },

        checkMisMatch: function () {
            if (this.$quoteCartTable && this.$quoteCartTable !== null && this.$quoteCartTable.table !== null) {
                let matched = [];
                if (this.matchedMapping.length) {
                    this.matchedMapping.map((item) => {
                        let items = [];
                        if (item.matchingFields) {
                            if (item.matchingFields.PO) {
                                items = item.matchingFields.PO;
                            } else if (item.matchingFields.EDI) {
                                items = item.matchingFields.EDI;
                            }
                        }

                        items.forEach((fields) => {
                            const fieldFromAPI = ['plant', 'billingBlockCode', 'reason', 'deliveryBlockCode', 'desiredVendor',
                                'wgExtNotes', 'wgIntNotes', 'storageLocation', 'customerLineNumber', 'customerPartNumber', 'extCustomerPartNumber',
                                'deliveryGroup', 'manualItemCategory', 'cntrtStDate', 'taxClassification', 'partNumber'];

                            const fieldFromGrid = ['warehouseList', 'billBlock', 'exceptionReason', 'delBlock', 'vendor',
                                'wgCustText', 'wgIntrNote', 'sloc', 'custLineNum', 'custPartNum', 'extCustomerPartNumber',
                                'delGroup', 'itemCategorySelected', 'cntrtStartDate', 'taxClass', 'partNo'];
                            if (fieldFromAPI.includes(fields)) {
                                fields = fieldFromGrid[fieldFromAPI.indexOf(fields)];
                            }

                            if (this.getColNumber(fields) !== '') {
                                matched.push({row: (item.entryNumber / 10) - 1, col: this.$quoteCartTable.propToCol(fields)});
                            }
                        });
                        return matched;
                    });
                }

                if (matched.length) {
                    _.each(matched, function (cell) {
                        if (this.$quoteCartTable.toVisualRow(cell.row) != null) {
                            this.$quoteCartTable.setCellMeta(this.$quoteCartTable.toVisualRow(cell.row), cell.col, 'className', 'highlightCell');
                        }
                    }.bind(this));
                }
            }
        },

        reRenderTable: function () {
            //need to re-render when table in view (after tab click), otherwise it doesn't render correctly
            setTimeout(function () {
                if (this.$quoteCartTable && this.$quoteCartTable !== null && this.$quoteCartTable.table !== null) {
                    this.resizeContainer();
                    this.$quoteCartTable.render();
                }
            }.bind(this), 0);
        },

        drawCheckboxInRowHeaders: function (row, TH) {
            const input = document.createElement('input');
            input.type = 'checkbox';
            if (row >= 0 && this.getDataAtRowProp(row, '0')) {
                input.checked = true;
            }

            Handsontable.dom.empty(TH);
            TH.appendChild(input);
        },

        changeCheckboxCell: function (event, coords) {
            const target = event.target;
            if (coords.col === -1 && target && target.nodeName === 'INPUT') {
                event.preventDefault();
                this.setDataAtRowProp(coords.row, '0', !target.checked);
            }
        },

        createJsonTableHeader: function () {
            this.tableHeader = [];
            this.tableColumnOrder = [];
            this.tableColumnWidth = [];
            this.jsonTableMap = [];
            this.jsonTableData = [];
            this.jsonTableBody = [];
            this.colHeaderMapping = [];
            this.hiddenColumnsArray = [];
            this.shouldShowConfiguratorArray = [];
            this.shouldShowConfiguratorColumn = true;
            this.callOnceForShowingConfigurator = true;
            let columnHeaderTable = {};
            let columnIndex = 0;
            let rowData = this.newjsonData.rows[0];
            this.newjsonData.columns.forEach((item, index) => {
                let columnNameFromTag = this.columnsData.find(obj => obj.name === item.name);
                if (item.name === 'custLineNum' && item.isMandatory) {
                    window.isCustomerLineNumberMandatory = true;
                }

                columnHeaderTable = {
                    header: columnNameFromTag ? columnNameFromTag.innerhtml : item.name,
                    name: item.name,
                    width: item.width,
                    id: item.id,
                    hideColumn: item.hideColumn,
                    isMandatory: item.isMandatory
                };

                this.colHeaderMapping.push(columnHeaderTable);
                if (item.name != 'checkbox') {
                    let headerHtml = columnNameFromTag ? columnNameFromTag.innerhtml : item.name;
                    columnIndex++;
                    let colName = columnNameFromTag ? columnNameFromTag.name : item.name;
                    let bulkTag = '<br>';
                    if ($('.enableVRFBulkUpdate').val() === 'true' && this.bulkUpdateTargets.includes(colName)) {
                        bulkTag += `<a id='bulkUpdateCol' class='bulkUpdateColClass' data-colnum='${colName}'>Bulk Update</a>`;
                    }

                    if (!['listPrice', 'purchasePrice'].includes(item.name) && rowData && rowData[item.name] && rowData[item.name].type === 'price') {
                        headerHtml += `<span class='column-price-marker'>In <b>${rowData[item.name].currency ? rowData[item.name].currency : this.newjsonData.headerLevelInfo.currency}</b></span>`;
                    }

                    headerHtml += `<br><div class='filterHeader'><input class='filter-input filter-${colName}' data-col='${columnIndex}' data-attr='${colName}'></input>` + bulkTag;
                    this.tableHeader.push(headerHtml);
                    this.tableColumnOrder.push(item.name);
                    this.tableColumnWidth.push(item.width);
                }
            });
        },

        createJsonTableData: function () {
            this.jsonTableMap = [];
            this.jsonTableData = [];
            this.jsonTableIdMap = [];
            this.newjsonData.rows.forEach((item) => {
                let itemObj = {};
                this.tableColumnOrder.forEach((cell) => {
                    cell = cell.includes('availability') ? 'availability' : cell;
                    if (cell === 'notes') {
                        itemObj[cell] = item[cell].note;
                    } else if (cell === 'id') {
                        itemObj[cell] = item.entryNumberString.value;
                    } else if (['billBlock', 'delBlock'].includes(cell) && !item[cell].value) {
                        itemObj[cell] = '--Please Select--';
                    } else if (['manualSBA', 'autoSBA'].includes(cell)) {
                        itemObj[cell] = item[cell].source.join(' ');
                    } else if (cell === 'sloc' && item[cell].value === '' && !_.isEmpty(this.productAvailabilityArray) && this.productAvailabilityArray[item.partNo.value]) {
                        let selectedPlant = item.plant.value ? item.plant.value.split('-')[0] : item.plant.value;
                        let plantObj = this.productAvailabilityArray[item.partNo.value][selectedPlant];
                        itemObj[cell] = plantObj ? plantObj.defaultSlocFromAvailabilityResp : '';
                    } else {
                        itemObj[cell] = item[cell].value;
                    }
                });

                this.jsonTableIdMap.push(item.id.value);
                this.jsonTableMap.push(item.id.value);
                this.jsonTableData.push(itemObj);
            });
        },

        createJsonTableBody: function () {
            let _this = this;
            let object = this.newjsonData.rows[0];
            this.tableColumnOrder.forEach((item)  => {
                let itemObj = {};
                if (item === 'checkbox') {
                    return;
                } else if (item === 'availabilityinSelectedPlant') {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.availabilitySelectedRenderer.bind(this)
                    };
                } else if (item.includes('availability')) {
                    itemObj = {
                        data: `${item}`,
                        renderer: isOrderEntrySite ? this.availabilityRenderer.bind(this) : this.customAvailabilityRenderer.bind(this)
                    };
                } else if (item === 'parentEntryNumber') {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.customParentEntryNumberRenderer.bind(this)
                    };
                } else if (item === 'id') {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.customIdRenderer.bind(this)
                    };
                } else if (item === 'notes' || object[item].type === 'textarea') {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.customNotesRenderer.bind(this)
                    };
                } else if (object[item].type === 'autocomplete') {
                    this.partNumberName = item;
                    itemObj = {
                        data: `${item}`,
                        type: 'autocomplete',
                        source (query, process) {
                            fetch(globals.path.api.quoting.quoteTablePartNoSearch + '?term=' + query)
                              .then(response => response.json())
                              .then(response => process(response));
                        },

                        renderer: this.customAutoCompleteCellRenderer.bind(this),
                        allowInvalid: true,
                        allowEmpty: true
                    };
                } else if (object[item].type === 'text') {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.customTextRenderer.bind(this)
                    };
                } else if (object[item].type === 'dropdown') {
                    itemObj = {
                        data: `${item}`,
                        type: 'dropdown',
                        renderer: this.customDropdownRenderer.bind(this)
                    };
                } else if (item === 'handlingUnitVAS') {
                    itemObj = {
                        data: `${item}`,
                        validator: this.simpleNumericValidator,
                        renderer: this.customNumericTextRenderer.bind(this)
                    };
                } else if (object[item].type === 'numeric') {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.customNumericRenderer.bind(this)
                    };
                } else if (['price', 'percentage'].includes(object[item].type)) {
                    itemObj = {
                        data: `${item}`,
                        allowEmpty: false,
                        validator: this.currencyValidator,
                        renderer: this.customPrefixSuffixRenderer.bind(this)
                    };
                } else if (object[item].type === 'date') {
                    itemObj = {
                        data: `${item}`,
                        type: 'date',
                        renderer: this.customDateRenderer.bind(this),
                        dateFormat: dateFormat,
                        placeholder: dateFormat
                    };
                } else if (object[item].type === 'autosba' || object[item].type === 'manualsba') {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.customManualSbaRenderer.bind(this)
                    };
                } else if (object[item].type === 'button') {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.customButtonRenderer.bind(this)
                    };
                } else {
                    itemObj = {
                        data: `${item}`,
                        renderer: this.customTextRenderer.bind(this)
                    };
                }

                this.jsonTableBody.push(itemObj);
            });
        },

        createDummyDataForEmptyHandsontable: function () {
            this.emptyHandsonObject = {};
            this.tableColumnOrder.forEach((item)  => {
                this.emptyHandsonObject[item] = '';
            });
        },

        customAutoCompleteCellRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let cellObject = this.newjsonData.rows[cellProperties.row];
            cellObject.isExpanded = cellObject.isExpanded === undefined ? true : cellObject.isExpanded;
            let columnObject = cellObject[cellProperties.prop];
            if (($('#allInvalidVendorProducts').val() === 'true' || cellObject.itemCategoryError || cellObject.itemCategoryMismatch || cellObject.daPriceMismatch) && value) {
                cellProperties.readOnly = true;
                if (!cellObject.entryNumberString.value) {
                    cellProperties.readOnly = false;
                }

                if (cellObject.itemCategoryError) {
                    cellProperties.tooltipTarget = 'error-partno';
                    cellProperties.className = 'tooltip-target';
                } else {
                    cellProperties.className = 'qut-table-error-item-category-mismatch';
                }

                value += `<span class='error-partnumber'>&#33;</span>`;
                this.hasCriticalError = true;
            }

            if (!cellObject.isEligibleForSparing && [true, 'true'].includes($('#sparingFeatureEnabled').val()) && cellObject.entryNumberString.value) {
                cellProperties.readOnly = true;
            } else if (cellObject.entryNumberString.value === '') {
                cellProperties.readOnly = false;
            }

            if (value && cellObject.childs && cellObject.childs.length) {
                let icon = cellObject.isExpanded ? 'icon-sign_minus' : 'icon-sign_plus';
                value = `<span class='qut-expand-icon ${icon}' data-childs='[${cellObject.childs}]' data-id='${cellProperties.row}'></span> ${value}`;
            }

            if (columnObject.disabled || (this.newjsonData.vendorCreditApplicable && cellObject.disableRow)) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.HtmlRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customParentEntryNumberRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let rowObject = this.newjsonData.rows[cellProperties.row];
            let cellObject = rowObject[cellProperties.prop];
            cellProperties.validator = this.simpleNumericValidator;
            if (rowObject.type === 'SCONTC') {
                value = `<span class='icon-information' data-id='${cellProperties.row}'></span>`;
                cellProperties.className = 'tooltip-target';
                cellProperties.tooltipTarget = prop;
            }

            cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
            if (this.newjsonData.vendorCreditApplicable && rowObject.disableRow) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.HtmlRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customButtonRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let rowObject = this.newjsonData.rows[cellProperties.row];
            let cellObject = rowObject[cellProperties.prop];
            if (this.newjsonData.vendorCreditApplicable && rowObject.disableRow) {
                cellObject.disabled = true;
            }

            if ([this.BLUE_SKY_TYPE, this.BLUE_SKY_PARENT_TYPE].includes(rowObject.type)) {
                var linkClass = 'button-link';
                if (cellObject.value && cellObject.value.length) {
                    this.shouldShowConfiguratorColumn = false;
                    if (this.BLUE_SKY_TYPE === rowObject.type) {
                        value = `<a class='button ${linkClass} ${cellObject.disabled ? 'disabled' : ''} cnfg-btn' style='padding:0px;margin: 0px; height: 24px;' ${cellObject.disabled ? 'disabled' : ''}>Configurator</a>`;
                    } else {
                        value = `<a class='button ${linkClass} ${cellObject.disabled ? 'disabled' : ''} mdfyConfig' style='padding:0px;margin: 0px; height: 24px;' ${cellObject.disabled ? 'disabled' : ''}>Modify Configurator</a>`;
                    }
                }
            }

            cellProperties.className = `configurator htDimmed`;
            cellProperties.readOnly = true;
            Handsontable.renderers.HtmlRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customPrefixSuffixRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let rowObj = this.newjsonData.rows[cellProperties.row];
            let cellObject = rowObj[cellProperties.prop];
            let decimal = this.newjsonData.headerLevelInfo.noOfDecimals;
            let additionalText = cellObject.type === 'price' ? (cellObject.currency ? cellObject.currency : this.newjsonData.headerLevelInfo.currency) : '%';
            cellProperties.validator = cellObject.type === 'price' ? this.currencyValidator : this.percentValidator;
            cellProperties.pricingColumn = true;
            if (cellObject) {
                let htmlElem = '';
                if (!['markUp', 'markUpPercentage'].includes(prop) || $('#allInvalidVendorProducts').val() === 'true') {
                    cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
                }

                if (['extendedCost', 'purchasePrice'].includes(prop)) {
                    cellProperties.tooltipTarget = 'total-uplift-link';
                    cellProperties.className = 'tooltip-target';
                }

                if (['listPrice', 'purchasePrice'].includes(prop)) {
                    cellProperties.thresholdPrice = rowObj.thresholdPrice;
                }

                if (rowObj.type === 'CREDITLINE' && ['listPrice', 'purchaseDiscount', 'purchasePrice', 'extendedCost'].includes(prop)) {
                    cellProperties.className += ' negativeLines';
                }

                if (value && !isNaN(value) && !['NA', 'N/A'].includes(value)) {
                    if (['resellerPrice', 'extendedPrice', 'purchasePrice'].includes(prop) && additionalText != '%') {
                        value = Number(value).toLocaleString('en-US', {minimumFractionDigits: decimal, maximumFractionDigits: decimal});
                    } else if (additionalText != '%') {
                        value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    }

                    if (['listPrice', 'purchasePrice'].includes(prop)) {
                        htmlElem = additionalText === '%' ? `${value} ${additionalText}` : `${additionalText} ${value}`;
                    } else {
                        htmlElem = value;
                    }
                } else if (['NA', 'N/A'].includes(value)) {
                    htmlElem = value;
                }

                if (this.newjsonData.vendorCreditApplicable && rowObj.disableRow) {
                    cellProperties.readOnly = true;
                }

                Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop, htmlElem, cellProperties]);
            }
        },

        customIdRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let cellObject = this.newjsonData.rows[cellProperties.row];
            cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.entryNumberString.disabled;
            cellProperties.entryType = cellObject.type;
            cellProperties.serviceEnforcement = cellObject.serviceEnforcement;
            cellProperties.isProductDeletionDisabled = cellObject.isProductDeletionDisabled;
            cellProperties.isParentShipSetEntry = cellObject.isParentShipSetEntry;
            cellProperties.lineType = cellObject.lineType;
            if (this.newjsonData.vendorCreditApplicable && cellObject.disableRow) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customTextRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let rowObject = this.newjsonData.rows[cellProperties.row];
            let cellObject = this.newjsonData.rows[cellProperties.row][cellProperties.prop];
            if (!['delGroup'].includes(prop)) {
                cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
            }

            if (['pricingCondition', 'description'].includes(prop) && (prop != 'pricingCondition' || value != 'none')) {
                cellProperties.className = 'tooltip-target';
                cellProperties.tooltipTarget = prop;
            }

            if (['custLineNum'].includes(prop)) {
                cellProperties.validator = this.customerLineNumberValidator;
                if (window.isCustomerLineNumberMandatory) {
                    td.className = 'mandatory';
                    cellProperties.isMandatory = true;
                }
            }

            if (this.newjsonData.vendorCreditApplicable && rowObject.disableRow) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customDropdownRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.DropdownRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
            let rowObject = this.newjsonData.rows[cellProperties.row];
            let cellObject = rowObject[cellProperties.prop];
            cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
            let dropdownValues = cellObject.source ? cellObject.source : (this.newjsonData.headerLevelInfo[prop] ? this.newjsonData.headerLevelInfo[prop] : []);

            if (cellProperties.prop === 'entryType') {
                if (['OPTIONAL', 'ALTERNATIVE'].includes(value)) {
                    this.$('tr[data-id="' + row + '"]').addClass('optional');
                } else {
                    this.$('tr[data-id="' + row + '"]').removeClass('optional');
                }
            }

            if (['exceptionReason', 'warehouseList', 'taxClass', 'durationUnit'].includes(cellProperties.prop) && !dropdownValues.includes('')) {
                dropdownValues.splice(0, 0, '');
            }

            if (this.newjsonData.vendorCreditApplicable && rowObject.disableRow) {
                cellProperties.readOnly = true;
            }

            cellProperties.source = dropdownValues;
        },

        customNumericRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let rowObject = this.newjsonData.rows[cellProperties.row];
            let cellObject = this.newjsonData.rows[cellProperties.row][cellProperties.prop];
            cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
            if (prop === 'quantity') {
                cellProperties.validator = this.customQuantityValidator;
            }

            if (this.newjsonData.vendorCreditApplicable && rowObject.disableRow) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.NumericRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customNumericTextRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let rowObject = this.newjsonData.rows[cellProperties.row];
            let cellObject = this.newjsonData.rows[cellProperties.row][cellProperties.prop];
            cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
            cellProperties.validator = this.simpleNumericValidator;
            cellProperties.maxLength = 20;
            if (this.newjsonData.vendorCreditApplicable && rowObject.disableRow) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customDateRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.DateRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
            let rowObject = this.newjsonData.rows[cellProperties.row];
            let cellObject = this.newjsonData.rows[cellProperties.row][cellProperties.prop];
            if (!['shipDate'].includes(prop)) {
                cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
            }

            if (this.newjsonData.vendorCreditApplicable && rowObject.disableRow) {
                cellProperties.readOnly = true;
            }
        },

        customAvailabilityRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            cellProperties.prop = cellProperties.prop.includes('availability') ? 'availability' : cellProperties.prop;
            let cellObject = this.newjsonData.rows[cellProperties.row];
            let availabilityObject = this.productAvailabilityObject[cellObject.partNo.value];
            let selectedPlant = cellObject.plant.value ? cellObject.plant.value.split('-')[0] : cellObject.plant.value;
            let selectedPlantObject = availabilityObject ? availabilityObject[selectedPlant] : '';
            let isIntangible = cellObject.isIntangible;
            if (isIntangible) {
                value = 'Electronic';
            } else if (selectedPlantObject) {
                if (this.defaultSlocLabel === 'DEFAULT') {
                    let slocList = selectedPlantObject.slocAvailability;
                    if (slocList) {
                        let selectedSloc = selectedPlantObject.defaultSlocFromAvailabilityResp;
                        value = slocList[selectedSloc] > 0 ? 'In Stock' : 'Out Of Stock';
                    } else {
                        value = 'Out Of Stock';
                    }
                } else if (this.defaultSlocLabel === 'TOTALSLOC') {
                    value = selectedPlantObject.stockLevel > 0 ? 'In Stock' : 'Out Of Stock';
                } else if (this.defaultSlocLabel === 'TOTALPLANT') {
                    let avTotal = 0;
                    _.each(availabilityObject, (item) => {
                        avTotal += item.stockLevel;
                    });

                    value = avTotal > 0 ? 'In Stock' : 'Out Of Stock';
                }

                cellProperties.className = 'tooltip-target';
                cellProperties.tooltipTarget = 'availability-link';
            }

            cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
            if (this.newjsonData.vendorCreditApplicable && cellObject.disableRow) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customNotesRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let rowObject = this.newjsonData.rows[cellProperties.row];
            let cellObject = this.newjsonData.rows[cellProperties.row][cellProperties.prop];
            let urlRegex = /(https?:\/\/[^\s]+)/g;
            let valueHasUrl = value ? value.match(urlRegex) : false;
            cellProperties.readOnly = $('#allInvalidVendorProducts').val() === 'true' ? true : cellObject.disabled;
            cellProperties.notesObject = cellObject;
            if (this.newjsonData.vendorCreditApplicable && rowObject.disableRow) {
                cellProperties.readOnly = true;
            }

            if (valueHasUrl) {
                let url = valueHasUrl[0];
                let textWithoutUrl = value.replace(url, '').trim();
                value = `<a data-field='${prop}' class='qut-table-notes ${cellProperties.readOnly ? 'pointerNone' : ''}'>${value ? (textWithoutUrl ? textWithoutUrl : url) : 'ADD'}</a>`;
            } else {
                value = `<a data-field='${prop}' class='qut-table-notes ${cellProperties.readOnly ? 'pointerNone' : ''}'>${value ? value : 'ADD'}</a>`;
            }

            Handsontable.renderers.HtmlRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customManualSbaRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let getSorceFromSba = '';
            let rowObj = this.newjsonData.rows[cellProperties.row];
            let cellObject = rowObj[cellProperties.prop];
            if (this.newjsonData.vendorCreditApplicable && rowObj.disableRow) {
                cellProperties.disabled = true;
            }

            if (cellObject.source && cellObject.source.length) {
                _.each(cellObject.source, (item) => {
                    getSorceFromSba += `<a data-sba-type="${cellObject.type}" data-deal-id="${item}" data-field='${cellProperties.row}' class='${cellObject.disabled && prop === 'manualSBA' ? '' : 'qut-table-sba '} ${prop === 'autoSBA' ? 'autotagsba' : ''}'>${item ? item : ''}</a>${!rowObj.isKnockOffSba && prop === 'manualSBA' && $('#subscriptionOrder').val() === 'false' && !cellObject.disabled ? `<span data-val='${item}' data-field='${cellProperties.row}' class="icon-closebutton remove-applied-sba"></span>` : ''} <br>`;
                });
            }

            cellProperties.readOnly = true;
            value = getSorceFromSba ? getSorceFromSba : '';
            Handsontable.renderers.HtmlRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        availabilityRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let cellObject = this.newjsonData.rows[cellProperties.row];
            let productAvailabilityObjects = this.productAvailabilityArray[cellObject.partNo.value];
            _.each(productAvailabilityObjects, item => {
                if (prop === item.countryCode) {
                    value = item;
                }
            });

            let attrToDisplay = 'stockLevel';
            let cellTexts = {
                inStock: 'In Stock',
                intangible: 'Electronic',
                outOfStock: 'Out of Stock'
            };

            let linkClass = 'availability-link-OE';
            let isIntangible = cellObject.isIntangible;
            let slocAvailability = 'slocAvailability';
            let shippingPointStorageLocation = 'shippingPointStorageLocation';
            let defaultSlocFromAvailabilityResp = 'defaultSlocFromAvailabilityResp';
            let shippingPoint = cellObject.shippingPoint;
            if (isIntangible) {
                value = cellTexts.intangible;
            } else {
                if (value) {
                    if (attrToDisplay === 'stockLevel') {
                        let slocList = value[slocAvailability];
                        if (slocList) {
                            let shippingPointStorageLocationList = value[shippingPointStorageLocation];
                            var selectedSloc;
                            if (!selectedSloc) {
                                selectedSloc = shippingPointStorageLocationList[shippingPoint];
                            }

                            if (!selectedSloc) {
                                selectedSloc = value[defaultSlocFromAvailabilityResp];
                            }

                            cellProperties.className = 'tooltip-target';
                            cellProperties.tooltipTarget = linkClass;
                            value = selectedSloc ? (slocList ? (slocList[selectedSloc] ? slocList[selectedSloc] : 0) : 0) : 0;
                        } else {
                            value = 0;
                            cellProperties.className = 'tooltip-target';
                            cellProperties.tooltipTarget = linkClass;
                        }
                    } else {
                        value = value[attrToDisplay];
                        cellProperties.className = 'tooltip-target';
                        cellProperties.tooltipTarget = linkClass;
                    }
                } else {
                    value = 0;
                }
            }

            if (this.newjsonData.vendorCreditApplicable && cellObject.disableRow) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        availabilitySelectedRenderer: function (instance, td, row, col, prop, value, cellProperties) {
            let cellObject = this.newjsonData.rows[cellProperties.row];
            let cellTexts = {
                inStock: 'In Stock',
                intangible: 'Electronic',
                outOfStock: 'Out of Stock'
            };

            var shippingPoint = cellObject.shippingPoint.value;
            var isIntangible = cellObject.isIntangible;
            var selectedSloc = cellObject.storageLocation.value;
            var selectedPlant = cellObject.plant.value ? cellObject.plant.value.split('-')[0] : cellObject.plant.value;
            if (!_.isEmpty(this.productAvailabilityArray) && this.productAvailabilityArray[cellObject.partNo.value]) {
                value = this.productAvailabilityArray[cellObject.partNo.value][selectedPlant];
            }

            var plant = 'plant';
            var slocAvailability = 'slocAvailability';
            var shippingPointStorageLocation = 'shippingPointStorageLocation';
            var defaultSlocFromAvailabilityResp = 'defaultSlocFromAvailabilityResp';
            if (isIntangible) {
                value = cellTexts.intangible;
            } else {
                if (value) {
                    if (selectedPlant === value[plant]) {
                        let slocList = value[slocAvailability];
                        if (slocList) {
                            let shippingPointStorageLocationList = value[shippingPointStorageLocation];
                            if (!selectedSloc) {
                                if (shippingPoint) {
                                    selectedSloc = shippingPointStorageLocationList[shippingPoint];
                                }

                                if (!selectedSloc) {
                                    selectedSloc = value[defaultSlocFromAvailabilityResp];
                                }
                            }

                            value = selectedSloc ? (slocList ? (slocList[selectedSloc] ? slocList[selectedSloc] : 0) : 0) : 0;
                        } else {
                            value = 0;
                        }
                    } else {
                        value = 0;
                    }
                } else {
                    value = 0;
                }
            }

            cellProperties.className = 'availabilityInSelectedPlant';
            if (this.newjsonData.vendorCreditApplicable && cellObject.disableRow) {
                cellProperties.readOnly = true;
            }

            Handsontable.renderers.TextRenderer.apply(this, [instance, td, row, col, prop, value, cellProperties]);
        },

        customQuantityValidator: function (value, callback, prop) {
            if (value === '' || value === null || value === undefined || isNaN(value) || value <= 0 || value % 1 !== 0) {
                callback(false);
            } else {
                callback(true);
            }
        },

        customerLineNumberValidator: function (value, callback, prop) {
            let regex = /^[0-9a-zA-Z.]+$/;
            if (regex.test(value) || value === '') {
                callback(true);
            } else {
                callback(false);
            }
        },

        tooltipCellEvents: function (e, cords) {
            cords.row = this.$quoteCartTable.toPhysicalRow(cords.row);
            let target = this.$quoteCartTable.getCellMeta(cords.row, cords.col).tooltipTarget;
            let model = this.newjsonData.rows[cords.row];

            if (this.tooltipTargets.includes(target)) {
                let isLastColumn = this.$quoteCartTable.countCols() === cords.col + 1;
                let radioNotRequired = this.isCellReadOnly(model, target) ? true : false;
                let template = isLastColumn ? '#comp-table-tooltip-left' : '#comp-table-tooltip-poscrap';
                let calssName = isLastColumn ? 'quoteTableTooltipLeft' : 'quoteTableTooltip';
                if (target === 'delGroup' || target === 'shipDate') {
                    radioNotRequired = this.requestShipcompleteEnabled;
                }

                if (target === 'parentEntryNumber') {
                    radioNotRequired = false;
                }

                this.eventAgg.trigger(calssName, {
                    follow: e.target,
                    pointerName: target,
                    currentRow: cords.row,
                    pricing: 'pricing',
                    model: model.fieldsMismatchData,
                    currency: model.currencyData,
                    vc: model.vCurrency,
                    isLastColumn: isLastColumn,
                    radioNotRequired: radioNotRequired,
                    template: _.template($(template).html())
                });
            } else {
                switch (target) {
                    case 'pricingCondition':
                        this.eventAgg.trigger('quoteTableTooltip', {
                            follow: e.target,
                            template: _.template($('#comp-table-tooltip-sba').html()),
                            model: {
                                data: this.newjsonData.rows[cords.row].pricingConditionToolTip
                            }
                        });

                        break;
                    case 'description':
                        this.eventAgg.trigger('quoteTableTooltip', {
                            follow: e.target,
                            html: this.$quoteCartTable.getDataAtCell(cords.row, cords.col)
                        });

                        break;
                    case 'total-uplift-link':
                        this.eventAgg.trigger('quoteTableTooltip', {
                            follow: e.target,
                            template: _.template($('#comp-table-tooltip-total-uplift').html()),
                            model: {
                                row: this.newjsonData.rows[cords.row],
                                column: {columnName: this.$quoteCartTable.colToProp(cords.col), currency: this.currency},
                                hasRebate: this.hasRebate
                            }
                        });

                        break;
                    case 'availability-link-OE':
                        let productAvailabilityObjects = this.productAvailabilityArray[model.partNo.value];
                        let obj = {};
                        _.each(productAvailabilityObjects, item => {
                            if (this.$quoteCartTable.colToProp(cords.col) === item.countryCode) {
                                obj = item;
                            }
                        });

                        var tooltipViewOE = new ws.views.quoteTableTooltipAvailablity({
                            model: new ws.models.quoteTableAvailabilityTooltipModel(obj)
                        });

                        this.eventAgg.trigger('quoteTableTooltip', {
                            follow: e.target,
                            html: tooltipViewOE.render().el,
                            onClose: tooltipViewOE.abort.bind(tooltipViewOE)
                        });

                        break;
                    case 'availability-link':
                        var tooltipView = new ws.views.quoteTableTooltipAvailablity({
                            model: new ws.models.quoteTableAvailabilityTooltipModel({
                                itemCategorySelected: undefined,
                                partNo: this.$quoteCartTable.getDataAtCell(cords.row, this.$quoteCartTable.propToCol('partNo')),
                                quoteId: $('#quoteCode').val()
                            })
                        });

                        this.eventAgg.trigger('quoteTableTooltip', {
                            follow: e.target,
                            html: tooltipView.render().el,
                            onClose: tooltipView.abort.bind(tooltipView)
                        });

                        break;
                    case 'error-partno':
                        this.eventAgg.trigger('quoteTableTooltip', {
                            follow: e.target,
                            template: _.template($('#comp-table-tooltip-part-number').html())
                        });

                        break;
                }

                //Removed this case to have values in parentEntryNumber modal instad of static message
                // case 'parentEntryNumber':
                //     this.eventAgg.trigger('quoteTableTooltip', {
                //         follow: e.target,
                //         html: '<div class="tooltip-body">This SKU is of Support contract child item</div>'
                //     });

                //     break;
            }
        },

        expandChildRows: function(e) {
            let $target = $(e.target);
            let childRows = $target.data('childs').map(item => item - 1);
            let hiddenRowsPlugin = this.$quoteCartTable.getPlugin('hiddenRows');
            if ($target.hasClass('icon-sign_minus')) {
                $target.removeClass('icon-sign_minus').addClass('icon-sign_plus');
                this.newjsonData.rows[$target.data('id')].isExpanded = false;
                hiddenRowsPlugin.hideRows(childRows);
            } else {
                $target.removeClass('icon-sign_plus').addClass('icon-sign_minus');
                this.newjsonData.rows[$target.data('id')].isExpanded = true;
                hiddenRowsPlugin.showRows(childRows);
            }

            this.$quoteCartTable.render();
            this.resizeContainer();
        },

        appendNewRowsToGridAndRenderTable: function (response, skipComparison) {
            window.totalAwsResellerPrice = '';
            let isNewItemAdded = false;
            this.eventAgg.trigger('updateTotalRowsOnDiscountView', null);
            this.eventAgg.trigger('updateSelectedRowsOnDiscountView', null);
            if (response.data.table.rows && response.data.table.rows.length === 0) {
                this.renderTable();
                return;
            }

            if (response.data.table.columns == null) {
                response.data.table.columns = this.newjsonData.columns;
            }

            if (!skipComparison) {
                response.data.table.rows.forEach(row => {
                    let alreadyExist = this.newjsonData.rows.some(item => item.id.value == row.id.value);
                    if (!alreadyExist) {
                        this.newjsonData.rows.push(row);
                        this.jsonTableIdMap.push(row.id.value);
                        isNewItemAdded = true;
                    } else {
                        this.newjsonData.rows[this.jsonTableIdMap.indexOf(row.id.value)] = row;
                    }

                });
            } else {
                this.newjsonData.rows = response.data.table.rows;
            }

            if (isNewItemAdded) {
                this.$quoteCartTable.destroy();
                this.renderTable();
            } else {
                if ($('#hasConfigureskusIdQuote').val() === 'true' && isQuotingSite) {
                    this.$quoteCartTable.destroy();
                    this.renderTable();
                } else {
                    this.jsonTableData = [];
                    this.createJsonTableData();
                    this.$quoteCartTable.updateData(this.jsonTableData);
                }
            }

            if (isQuotingSite) {
                this.renderBillingTabQuoting(response);
                this.updateVendorCreditApplicableChangesQuoting(response.vendorCreditApplicable);
            } else if (isOrderEntrySite) {
                this.renderBillingTabOE(response);
                this.updateVendorCreditApplicableChangesOE(response.vendorCreditApplicable);
            }
        },

        hiddenColumnFn: function (res) {
            this.hiddenColumnsArray = [];
            _.each(res.columns, (column) => {
                if (column.hideColumn) {
                    this.hiddenColumnsArray.push(column.id - 1);
                }
            });
        },

        bindEventsToHoT: function () {
            $(document).on('keyup', '.filter-input', (e) => {
                this.debouncePricingFn($(e.target).data('attr'), e);
            });

            //On focus of filter all selection will be removed hence needs an update
            $(document).on('focus', '.filter-input', (e) => {
                this.selectedRowIds = [];
                this.selectedVisualRows = [];
                this.mapPhysicalRowsOfSelectedRows();
            });

            $(document).on('click', '.applied-filters .remove-plugin-filter', (e) => {
                this.removePricingAppliedFilter(e);
            });

            $(document).on('keyup', '.pricingUpdateInputChange, .pricingUpdateDateChange, .qut-table-comment-text-bulk, .qut-table-purchaseOrder-text-bulk', (e) => {
                this.pricingBulkUpdateModalChangee(e);
            });

            $(document).on('change', '.pricingUpdateDropdownChange, .pricingUpdateDateChange, .qut-table-comment-text-bulk, .qut-table-purchaseOrder-text-bulk, input[name="qut-comments-radio-bulk"]', (e) => {
                this.pricingBulkUpdateModalChangee(e);
            });

            $(document).on('click', '.remove-filter-and-continue-add', (e) => {
                this.removeFiltersAndContinueAddProducts(e);
            });
        },

        reAppendValuesToFilteredInputs: function () {
            for (const [key, value] of Object.entries(this.filterConditions)) {
                $(`.filter-${key}`).val(value);
            }
        },

        removePricingAppliedFilter: function (e) {
            e.preventDefault();
            let filtersPlugin = this.$quoteCartTable.getPlugin('filters');
            if ($(e.target).hasClass('remove-filter-all')) {
                filtersPlugin.clearConditions();
                this.filterConditions = {};
            } else {
                filtersPlugin.clearConditions([$(e.currentTarget).data('column')]);
                delete this.filterConditions[this.$quoteCartTable.colToProp($(e.currentTarget).data('column'))];
            }

            filtersPlugin.filter();
            this.deleteZeroValueButtonDisplay(this.deleteZeroValueLineItems);
        },

        appendGridWarningMessages: function (warningMessages) {
            let gridWarningTarget = isQuotingSite ? $('.quote-product-warnings') : $('.gridWarningMessages');
            let warningHtml = '';
            warningMessages.forEach((message) => {
                warningHtml += `<p>${message}</p>`;
            });

            gridWarningTarget.empty().html(warningHtml);
            gridWarningTarget.removeClass('hide').show();
        },

        renderBillingTabQuoting: function(res) {
            if (res.displayBillingTab) {
                this.eventAgg.trigger('getBillingDetails');
                $('.billing-view-tab-link').removeClass('hidden');
                if ($('.billing-view-tab-link').closest('.showHideIfChild').length > 0) {
                    $('.showHideIfChild').css('display', 'block');
                }

                $('.palo-reset-pricing-instruction').removeClass('hide');
                $('.validate-pricing-palo-message').removeClass('hide');
                $('.validate-pricing-existing-message, .validate-pricing-creditline-message').addClass('hide');
                $('.apply-discount-palo-message').removeClass('hide');
            } else {
                $('#palostartdate').val('');
                $('.billing-view-tab-link').addClass('hidden');
                $('.palo-reset-pricing-instruction').addClass('hide');
                $('.validate-pricing-palo-message').addClass('hide');
                $('.validate-pricing-existing-message').removeClass('hide');
                $('.apply-discount-palo-message').addClass('hide');
            }
        },

        renderBillingTabOE: function (res) {
            if (res.displayBillingTab) {
                this.eventAgg.trigger('getBillingDetails');
                $('.billing-view-tab-link').removeClass('hide');
                $('.palo-reset-pricing-instruction').removeClass('hide');
                $('.validate-pricing-palo-message').removeClass('hide');
                $('.validate-pricing-existing-message, .validate-pricing-creditline-message').addClass('hide');
                $('.apply-discount-palo-message').removeClass('hide');
            } else {
                $('#palostartdate').val('');
                $('.billing-view-tab-link').addClass('hide');
                $('.palo-reset-pricing-instruction').addClass('hide');
                $('.validate-pricing-palo-message').addClass('hide');
                $('.validate-pricing-existing-message').removeClass('hide');
                $('.apply-discount-palo-message').addClass('hide');
            }
        },

        updateVendorCreditApplicableChangesQuoting: function (vendorCreditApplicable) {
            if (vendorCreditApplicable) {
                $('.vendor-credit-applicable-enduser').removeClass('hide');
                $('.validate-pricing-creditline-message').removeClass('hide');
                $('.validate-pricing-existing-message, .validate-pricing-palo-message').addClass('hide');
                $('.apply-discount-creditline-message').removeClass('hide');
            } else {
                $('.vendor-credit-applicable-enduser').addClass('hide');
                $('.validate-pricing-creditline-message').addClass('hide');
                $('.validate-pricing-existing-message').removeClass('hide');
                $('.apply-discount-creditline-message').addClass('hide');
            }
        },

        updateVendorCreditApplicableChangesOE: function (vendorCreditApplicable) {
            if (vendorCreditApplicable) {
                $('.validate-pricing-creditline-message').removeClass('hide');
                $('.validate-pricing-existing-message, .validate-pricing-palo-message').addClass('hide');
            } else {
                $('.validate-pricing-creditline-message').addClass('hide');
                $('.validate-pricing-existing-message').removeClass('hide');
            }
        },

        renderTable: function (res) {
            this.hasCriticalError = false;
            window.totalAwsResellerPrice = '';
            if (res && isQuotingSite) {
                this.renderBillingTabQuoting(res);
                this.updateVendorCreditApplicableChangesQuoting(res.vendorCreditApplicable);
            } else if (res && isOrderEntrySite) {
                this.renderBillingTabOE(res);
                this.updateVendorCreditApplicableChangesOE(res.vendorCreditApplicable);
            }

            if (res && (res.warningMessages)) {
                $('.gridWarningMessages').addClass('hide').hide();
                this.appendGridWarningMessages(res.warningMessages);
            } else if (res && res.warningMessages === null) {
                $('.gridWarningMessages').addClass('hide').hide();
            }

            $('.qut-delete-row').addClass('disabled');
            if (res) {
                this.defaultSlocLabel = res.defaultSlocLabel;
                res.data.table.headerLevelInfo.billBlock = $('#billingBlockDropdownDataArray').data('options');
                res.data.table.headerLevelInfo.delBlock = $('#deliveryBlockDropdownDataArray').data('options');
                if (res.data.table.columns === null) {
                    res.data.table.columns = this.newjsonData.columns;
                }

                this.newjsonData = res.data.table;
                this.newjsonData.vendorCreditApplicable = res.vendorCreditApplicable;
                this.hasRebate = res.hasRebate;
            }

            let _this = this;
            if (this.$quoteCartTable) {
                if (!this.$quoteCartTable.isDestroyed) {
                    this.$quoteCartTable.destroy();
                }
            }

            if (this.newjsonData.rows && this.newjsonData.rows.length) {
                this.createJsonTableHeader();
                this.createJsonTableBody();
                this.createJsonTableData();
            } else {
                this.createJsonTableHeader();
                this.createDummyDataForEmptyHandsontable();
            }

            this.hiddenColumnFn(this.newjsonData);
            const renderTableIfNeded = Handsontable.helper.debounce(() => {
                if (isOrderEntrySite && $('.entrylineLevelOptions input:checkbox:checked').length) {
                    this.checkMisMatch();
                    this.callMismatchApi();
                }

                this.$quoteCartTable.updateSettings({hiddenColumns: {
                    columns: this.hiddenColumnsArray
                }});

            }, 400);

            this.debouncePricingFn = Handsontable.helper.debounce((colAttr, event) => {
                if (event.target.value === '') {
                    delete this.filterConditions[colAttr];
                } else {
                    this.filterConditions[colAttr] = event.target.value;
                }

                let colIndex = this.$quoteCartTable.propToCol(colAttr);
                let filtersPlugin = this.$quoteCartTable.getPlugin('filters');
                filtersPlugin.removeConditions(colIndex);
                if (event.target.value != '') {
                    filtersPlugin.addCondition(colIndex, 'contains', [event.target.value]);
                }

                filtersPlugin.filter();
            }, 200);

            const doNotSelectColumn = function (event, coords) {
                if (event.target.nodeName === 'LABEL') {
                    event.stopImmediatePropagation();
                    this.deselectCell();
                    _this.selectColumn(event);
                } else if (coords.row === -1 && event.target.nodeName === 'INPUT') {
                    event.stopImmediatePropagation();
                    this.deselectCell();
                }
            };

            this.renderTableTooltip();
            this.$quoteCartTable = new Handsontable(this.$tableContainer, {
                data: this.jsonTableData.length ? this.jsonTableData : [this.emptyHandsonObject],
                manualColumnResize: true,
                filters: true,
                dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'],
                fixedColumnsLeft: 4,
                fillHandle: {
                    direction: 'vertical',
                    autoInsertRow: false
                },
                contextMenu: ['row_above', 'row_below'],
                colWidths: this.tableColumnWidth,
                invalidCellClassName: 'error',
                columns: this.jsonTableBody.length ? this.jsonTableBody : '',
                colHeaders: this.tableHeader,
                rowHeaders: () => '',
                manualColumnMove: false,
                manualRowMove: true,
                rowHeights: 29,
                hiddenRows: true,
                hiddenColumns: true,
                width: '100%',
                height: 500,
                licenseKey: 'bcf78-c247f-c7d42-54b3c-96c5f',
                beforeOnCellMouseDown: doNotSelectColumn,
                afterGetColHeader: function (column, TH) {
                    _this.reAppendValuesToFilteredInputs();
                },

                afterGetRowHeader: function (row, TH) {
                    TH.parentElement.setAttribute('data-id', this.toPhysicalRow(row));
                },

                afterRender: function (ifForced) {
                    _this.initializeComponents();
                    _this.renderTopScroller();
                    if (isOrderEntrySite) {
                        _this.checkMisMatch();
                        _this.callMismatchApi();
                        _this.checkSelectedCheckBoxes();
                        _this.checkForPriceProtectionDate();
                    }

                },

                beforeKeyDown: function (event) {
                    let editor = this.getActiveEditor();
                    if (editor != undefined) {
                        if ([46, 8].includes(event.keyCode) && !['cntrtStartDate', 'cntrtEndDate', 'groupId', 'groupDescription'].includes(editor.prop)) {
                            event.stopImmediatePropagation();
                            return false;
                        }

                        if (editor.prop === 'handlingUnitVAS' && editor.getValue().length >= 20) {
                            $(editor.TEXTAREA).attr('maxlength', 20);
                            event.stopImmediatePropagation();
                            return false;
                        }

                        if (['resellerPrice', 'extendedPrice'].includes(editor.prop)) {
                            let intString = (editor.getValue()).toString();
                            let intLength;
                            if (intString.startsWith('.')) {
                                $(editor.TEXTAREA).attr('maxlength', 3);
                            } else if (!intString.startsWith('.')) {
                                intLength = parseInt(editor.getValue()).toString().length;
                                let length = _this.resellerDecimalPoints + intLength + 1;
                                $(editor.TEXTAREA).attr('maxlength', length);
                            } else {
                                $(editor.TEXTAREA).removeAttr('maxlength');
                            }
                        } else {
                            $(editor.TEXTAREA).removeAttr('maxlength');
                        }
                    }
                },

                beforeCreateRow: function (index, amount, source) {
                    if ($('#qut-table-3pl').val() === 'true' || _this.isQuoteReadOnly) {
                        return false;
                    }

                    if ($('.remove-plugin-filter.remove-filter-all').length) {
                        _this.filterCheckAction = source === 'ContextMenu.rowAbove' ? 'insert_row_above' : 'insert_row_below';
                        _this.filterCheckActionIndex = index;
                        _this.eventAgg.trigger('removeFilterToContinueModal');
                        return false;
                    } else {
                        let hasEmptyRow = this.getDataAtCol(this.propToCol('id')).some(item => !item);
                        if (_this.newjsonData.rows.length === 0 || hasEmptyRow) {
                            return false;
                        }

                        let newRow = _this.newjsonData.rows.length ? JSON.parse(JSON.stringify(_this.newjsonData.rows[_this.newjsonData.rows.length - 1])) : _this.emptyHandsonObject;
                        newRow.id.value = String(_this.newjsonData.rows.length + 1);
                        _this.jsonTableIdMap.push(String(_this.newjsonData.rows.length + 1));
                        newRow.entryNumberString.value = '';
                        ['autoSBA', 'manualSBA'].forEach(item => {
                            if (newRow[item]) {
                                newRow[item].source = [];
                            }
                        });

                        ['blueSkyConfigurator'].forEach(item => {
                            if (newRow[item]) {
                                newRow[item].value = null;
                            }
                        });

                        newRow.itemCategoryError = newRow.itemCategoryMismatch = newRow.daPriceMismatch = false;
                        _this.newjsonData.rows.push(newRow);
                    }
                },

                afterCreateRow: function () {
                    _this.resizeContainer();
                },

                beforeFilter: function (obj) {
                    _this.checkIfInvalidRowExistAndRemove('filter');
                    $('.applied-filters ul').empty();
                    if (obj.length) {
                        $('.applied-filters ul').append(`<li><b>Delete all filter<span class='remove-plugin-filter remove-filter-all' data-column='all'>&times;</span></b></li>`);
                        obj.forEach(item => {
                            $('.applied-filters ul').append(`<li>${this.colToProp(item.column)}<span class='remove-plugin-filter' data-column='${item.column}'>&times;</span></li>`);
                        });
                    }
                },

                afterFilter: function (conditions) {
                    _this.resizeContainer();
                    _this.uncheckDeselect();
                    if (!isOrderEntrySite) {
                        _this.countRowsAfterFilterForApplyDiscount(true);
                    }
                },

                afterOnCellMouseDown: function (event, coords, td) {
                    _this.editedRow = coords.row;
                    _this.editedCol = coords.col;
                    let $el = $(event.target);
                    let currentRow = _this.newjsonData.rows[this.toPhysicalRow(coords.row)];
                    if ($el.hasClass('qut-expand-icon')) {
                        _this.expandChildRows(event);
                    }

                    if (event.target.id === 'bulkUpdateCol' && !_this.checkIfInvalidRowExistAndRemove()) {
                        _this.openBulkUpdatePricingModal(event, coords);
                    }

                    if ($el.hasClass('qut-table-notes') && !_this.checkIfInvalidRowExistAndRemove()) {
                        let partNumber = this.getDataAtCell(coords.row, this.propToCol('partNo'));
                        let noteObject = this.getCellMeta(coords.row, coords.col).notesObject;
                        let commentData = {};
                        let urlRegex = /(https?:\/\/[^\s]+)/g;
                        let noteWithUrl = noteObject.note ? noteObject.note.match(urlRegex) : false;
                        let valueWithUrl = noteObject.value ? noteObject.value.match(urlRegex) : false;

                        if (isOrderEntrySite) {
                            let field = $el.data('field') || 'notes';
                            var title = $('th[data-name=' + field + ']').html();
                            commentData = {
                                partNo: partNumber,
                                row: coords.row,
                                col: coords.col,
                                title: title,
                                field: field,
                                value: {
                                    hyperlink: valueWithUrl ? `<a href="${valueWithUrl[0]}" target="_blank">${noteObject.value.replace(urlRegex, '').trim() ? noteObject.value.replace(urlRegex, '').trim() : noteObject.value}</a>` : noteObject.value,
                                    note: noteObject.value,
                                    isUrl: !!valueWithUrl
                                },
                            };
                        } else {
                            commentData = {
                                partNo: partNumber,
                                row: this.toPhysicalRow(coords.row),
                                hyperlink: noteWithUrl ? `<a href="${noteWithUrl[0]}" target="_blank">${noteObject.note.replace(urlRegex, '').trim() ? noteObject.note.replace(urlRegex, '').trim() : noteObject.note}</a>` : noteObject.note,
                                note: noteObject.note,
                                poText: noteObject.poText,
                                showNote: noteObject.showNote,
                                isUrl: !!noteWithUrl
                            };
                        }

                        _this.eventAgg.trigger('qut-tableShowComments', commentData);
                    }

                    if ($el.hasClass('remove-applied-sba')) {
                        _this.deleteSbaFromRow(event, coords);
                    }

                    if ($el.hasClass('qut-table-sba')) {
                        _this.eventAgg.trigger('showSBAInfo', $el);
                    }

                    if (!$el.hasClass('disabled') && $el.hasClass('button-link') && [_this.BLUE_SKY_TYPE, _this.BLUE_SKY_PARENT_TYPE].includes(currentRow.type)) {
                        this.isIframeTriggered = true;
                        let endUser = $('#endUserUid').val() || $('#end-user-account').val();
                        let salesOrg = $('#sales-org-input').val() || $('.salesOrg').val();
                        if (endUser) {
                            _this.getPartnerKey = new ws.models.getPartnerKey({
                                quoteId: isOrderEntrySite ? $('.order-meta-data').data('order-number') : $('#quoteCode').val(),
                                salesOrg: salesOrg
                            });

                            globals.disableApp();
                            _this.getPartnerKey.save().done(function (response) {
                                globals.enableApp();
                                let reseller = $('[name=sba-resellerAccount]').val();
                                _this.eventAgg.trigger('configuratorModal', currentRow.partNo.value, currentRow.id.value, response, salesOrg, endUser, reseller);
                            }.bind(this)).fail(function(response) {
                                globals.enableApp();
                                console.error(response);
                            }.bind(this));
                        } else {
                            _this.eventAgg.trigger('qut-end-user-mandatory');
                        }
                    }
                },

                afterOnCellMouseOver: function (event, coords, td) {
                    if ($(event.target).hasClass('tooltip-target')) {
                        _this.tooltipCellEvents(event, coords);
                    }

                    _this.currentCellCoords = coords;
                    _this.currentTD = td;
                },

                beforeChange: function (changes, source) {
                    if (changes && changes.length && source !== 'manualUpdate') {
                        let hasManualUpdateCol = false;
                        changes.forEach(item => {
                            if (Number(item[2]) != Number(item[3]) && ['purchasePrice', 'purchaseDiscount'].includes(item[1]) && _this.newjsonData.rows[this.toPhysicalRow(item[0])] && _this.newjsonData.rows[this.toPhysicalRow(item[0])].sapPricingConditionType === 'ZWGS') {
                                hasManualUpdateCol = true;
                            }
                        });

                        if (hasManualUpdateCol) {
                            _this.eventAgg.trigger('manualUpdateGlobalPointsScalingAlert');
                            _this.manualUpdateGlobalPointData = changes;
                            return false;
                        }
                    }

                    if (changes && changes.length && source === 'edit' && changes[0][3] === '' && this.getCellMeta(changes[0][0], this.propToCol(changes[0][1])).pricingColumn) {
                        _this.removePendingClass();
                        return false;
                    }

                    if (!['customerPartNumber', 'partNo', 'partNumber'].includes(changes[0][1]) && _this.checkIfInvalidRowExistAndRemove('change')) {
                        _this.removePendingClass();
                        return false;
                    }

                    if (changes && changes.length) {
                        if (changes[0][1] === 'itemCategorySelected' && source === 'Autofill.fill') {
                            _this.removePendingClass();
                            return false;
                        }
                    }

                    let hiddenRows = this.getPlugin('hiddenRows');
                    changes.forEach(change => {
                        let [row, column, oldValue, newValue] = change;
                        if (!isNaN(column)) {
                            change[1] = this.colToProp(column);
                        }

                        if (column === 'custLineNum') {
                            _this.$quoteCartTable.getCellMeta(row, _this.$quoteCartTable.propToCol('custLineNum')).valid = true;
                        }

                        change[3] = change[3] === '--Please Select--' ? '' : change[3];
                        if (this.getCellMeta(row, this.propToCol(column)).pricingColumn) {
                            change[3] = change[3].replace(/^[\$,]+|[\%,]+$/g, '').replace(/,/g, '');
                        }

                        if (hiddenRows.isHidden(row)) {
                            change[3] = change[2];
                        }
                    });

                    return changes;
                },

                afterChange: function (changes, source) {
                    if (this.isValid === false) {
                        this.isValid = true;
                        _this.removePendingClass();
                        return;
                    }

                    if (source === 'edit' && changes && changes.length > 1 && changes.every(item => item[1] === 'cntrtStartDate')) {
                        _this.removePendingClass();
                        return false;
                    }

                    if (changes && changes.length) {
                        if (changes[0][1] === 'quantity' && (isNaN(changes[0][3]) || changes[0][3] < 0)) {
                            _this.removePendingClass();
                            _this.addErrorToCell();
                            return;
                        }

                        changes = changes.filter(item => item[2] != item[3]);
                        let physicalRows = changes.map(item => item[0] = this.toPhysicalRow(item[0]));
                    }

                    if (changes && changes.length && source != 'silent') {
                        let isListPriceCostPrice = ['listPrice', 'purchasePrice'].includes(changes[0][1]);
                        let listPriceVal, costPriceVal, thresholdPrice;
                        if (isListPriceCostPrice && changes.length === 1 ) {
                            listPriceVal = changes[0][1] === 'listPrice' ? Number(changes[0][2]) : this.getDataAtCell(this.toVisualRow(changes[0][0]), this.propToCol('listPrice'));
                            costPriceVal = changes[0][1] === 'purchasePrice' ? Number(changes[0][2]) : this.getDataAtCell(this.toVisualRow(changes[0][0]), this.propToCol('purchasePrice'));
                            thresholdPrice = this.getCellMeta(changes[0][0], this.propToCol(changes[0][1])).thresholdPrice;
                        }

                        if (changes[0][1] === 'notes' && source === 'Autofill.fill') {
                            _this.notesDragHandle(changes);
                        } else if (
                            (isQuotingSite && (
                                (listPriceVal === 0 || listPriceVal <= thresholdPrice) ||
                                (costPriceVal === 0 || costPriceVal <= thresholdPrice)
                            )) ||
                            (isOrderEntrySite &&
                                ['listPrice', 'purchasePrice'].includes(changes[0][1]) &&
                                changes.length === 1 &&
                                (Number(changes[0][2]) === 0 || Number(changes[0][2]) <= this.getCellMeta(changes[0][0], this.propToCol(changes[0][1])).thresholdPrice)
                            )
                        ) {
                            const model = {
                                id: changes[0][0] + 1,
                                partNo: this.getDataAtCell(this.toVisualRow(changes[0][0]), this.propToCol('partNo'))
                            };
                        
                            _this.eventAgg.trigger('renderListPriceCostOverlay', changes[0][1], model, isOrderEntrySite ? 'orderEntrySite' : 'quotingSite');
                        } else {
                            let hasDifferentValues = false;
                            if (source === 'CopyPaste.paste') {
                                let sampleValue = changes[0][3];
                                hasDifferentValues = changes.some(item => item[3] != sampleValue);
                            }

                            if (['custPartNum', 'customerPartNumber', 'partNo', 'partNumber'].includes(changes[0][1])) {
                                if (isOrderEntrySite) {
                                    if (changes[0][2] === null || changes[0][2] === '') {
                                        _this.addNewProductInline(changes[0], changes[0][1]);
                                    } else {
                                        _this.eventAgg.trigger('removeRowAndAddNewRow', changes);
                                    }
                                } else {
                                    _this.eventAgg.trigger('quoteTable:partNoChanged', changes[0]);
                                }
                            } else if (['cntrtStartDate', 'cntrtEndDate'].includes(changes[0][1])) {
                                _this.checkForContractDates(changes);
                            } else if (changes[0][1] === 'parentEntryNumber') {
                                if (changes[0][3] === '') {
                                    _this.removeErrorFromCell();
                                }

                                _this.addAssociationToQuote(changes);
                            } else if (!hasDifferentValues && changes[0][1] != 'quantity') {
                                _this.updateExistingProduct(changes);
                            } else if (hasDifferentValues || changes[0][1] === 'quantity') {
                                _this.updateMultipleProducts(changes);
                            }
                        }
                    }
                },

                afterSelectionEnd: function (startRow, column, endRow) {
                    _this.selectedRowIds = [];
                    _this.selectedVisualRows = [];
                    _this.deselectRowAndSelectSelected();
                    _this.calculateSum(startRow, column, endRow);
                },

                afterValidate: function (isValid, value, row, prop, source) {
                    let col = this.propToCol(prop);
                    let relatedCell;
                    if (isValid === false) {
                        this.isValid = false;
                    }

                    if (isValid) {
                        _this.removeErrorFromCell();

                        // The contract dates are marked as invalid together, so we need to remove it from both of them
                        if (prop === 'cntrtStartDate' || prop === 'cntrtEndDate') {
                            relatedCell = _this.findRelatedCell(prop, col, row);
                            _this.removeErrorFromCell(relatedCell, true);
                        }
                    }
                },

                beforeColumnMove: function (movedColumns, finalIndex) {
                    if (finalIndex < 4 || movedColumns.some(col => col < 4)) {
                        return false;
                    }
                },

                afterColumnMove: function (startColumn, endColumn) {
                    var fixedColumns = this.getSettings().fixedColumnsLeft;

                    //update col width of new column to match the original column width
                    if (startColumn >= fixedColumns && endColumn >= fixedColumns) {
                        var colWidths = this.getSettings().colWidths;
                        var startWidth = colWidths[startColumn];

                        colWidths.splice(startColumn, 1);
                        colWidths.splice(endColumn, 0, startWidth);
                        this.updateSettings({colWidths: colWidths});
                        _this.saveColumnSettings();
                    }
                },

                afterColumnResize: function (currentColumn, newSize) {
                    var colNumber = this.countCols();
                    var columnWidths = [];

                    for (var i = 0; i < colNumber; i++) {
                        columnWidths.push(this.getColWidth(i));
                    }

                    this.updateSettings({colWidths: columnWidths});
                    _this.saveColumnSettings();
                },

                beforeRowMove: function (startColumn, endColumn) {
                    let selectedArr = this.getSelected();
                    if (selectedArr.length === 1) {
                        startColumn = selectedArr[0][0];
                        let startDrag = this.toPhysicalRow(selectedArr[0][0]);
                        let topToBottomDrag = false;
                        let bottomToTopDrag = false;

                        if ((startColumn + 1) > endColumn) {
                            endColumn = endColumn + 1;
                            bottomToTopDrag = true;
                        } else {
                            endColumn = endColumn + 1;
                            topToBottomDrag = true;
                        }

                        if ((startColumn + 1) !== endColumn) {
                            const startmodel = _this.newjsonData[startDrag];
                            const endPreviousmodel = _this.newjsonData[endColumn - 2];
                            const endmodel = _this.newjsonData[endColumn - 1];
                            const endAftermodel = _this.newjsonData[endColumn];
                            const childBundles = ['RCB', 'TCB'];
                            const parentBundles = ['RPB', 'TPB'];
                            const ParentChildBundles = ['RPB', 'TPB', 'RCB', 'TCB'];
                            if (startmodel ? childBundles.includes(startmodel.type) : '') {
                                console.log('Should not Drag the Childs');
                                _this.dragAndDropRefresh();
                            } else if (endmodel ? ParentChildBundles.includes(endmodel.type) : '') {
                                if (childBundles.includes(endmodel.type) && topToBottomDrag) {
                                    if (endAftermodel ? parentBundles.includes(endAftermodel.type) || endAftermodel.type === 'STD' : true) {
                                        _this.dragAndDropAPI(startColumn + 1, endColumn);
                                    } else {
                                        console.log('Should not Drag into Childs');
                                        _this.dragAndDropRefresh();
                                    }
                                } else if (parentBundles.includes(endmodel.type) && bottomToTopDrag) {
                                    if (endPreviousmodel ? childBundles.includes(endPreviousmodel.type) || endPreviousmodel.type === 'STD' : true) {
                                        _this.dragAndDropAPI(startColumn + 1, endColumn);
                                    } else {
                                        console.log('Should not Drag into Childs');
                                        _this.dragAndDropRefresh();
                                    }
                                } else {
                                    console.log('Should not Drag into Childs');
                                    _this.dragAndDropRefresh();
                                }
                            } else {
                                if ($('.optionalQuote').val() === 'true') {
                                    _this.dragAndDropRefresh();
                                } else {
                                    _this.dragAndDropAPI(startColumn + 1, endColumn);
                                }
                            }
                        }
                    } else {
                        console.log('Should not Drag more than one Row');
                        _this.deselectRowAndSelectSelected(startColumn);
                        return false;
                    }
                }
            });

            window.handsOnTableCopy = this.$quoteCartTable;
            this.afterHandsontableCreationMethods();
            this.$quoteCartTable.addHook('afterScrollVertically', renderTableIfNeded);
            this.$quoteCartTable.addHook('afterScrollHorizontally', renderTableIfNeded);
        },

        calculateSum: function (startRow, column, endRow) {
            if (startRow < 0) {
                return;
            }

            let hiddenPlugin = this.$quoteCartTable.getPlugin('hiddenRows');
            if (startRow > endRow) {
                let startRowTemp = startRow;
                startRow = endRow;
                endRow = startRowTemp;
            }

            if (startRow != endRow && ['resellerPrice', 'extendedPrice'].indexOf(this.$quoteCartTable.colToProp(column)) !== -1) {
                let sum = 0;
                let currency = this.newjsonData.headerLevelInfo.currency;
                for (let i = startRow; i <= endRow; i++) {
                    let rowObject = this.newjsonData.rows[this.$quoteCartTable.toPhysicalRow(i)];
                    let portalCheck = true;
                    if (isOrderEntrySite) {
                        if ($('#cloudAnnuityOrder').val()) {
                            portalCheck = !['RCB', 'TCB', 'VIC', 'CREDITLINE', 'EXPANDED'].includes(rowObject.type);
                        } else {
                            portalCheck = !['RCB', 'TCB', 'VIC', 'VPSC', 'CREDITLINE', 'EXPANDED'].includes(rowObject.type);
                        }
                    } else if ($('#cloudAnnuityOrder').val()) {
                        portalCheck = !['SCONTC', 'RCB', 'TCB', 'VIC', 'FULL_TERM_ITEM_CHILD', 'PER_UNIT_SUBSCRIPTION', 'CREDITLINE', 'EXPANDED'].includes(rowObject.type);
                    }   else {
                        portalCheck = !['SCONTC', 'RCB', 'TCB', 'VIC', 'VPSC', 'FULL_TERM_ITEM_CHILD', 'PER_UNIT_SUBSCRIPTION', 'CREDITLINE', 'EXPANDED'].includes(rowObject.type);
                    }

                    if (!hiddenPlugin.isHidden(i) && portalCheck && !['CREDITLINE', 'EXPANDED'].includes(rowObject.lineType)) {
                        let celVal = this.$quoteCartTable.getDataAtCell(i, column) ? this.$quoteCartTable.getDataAtCell(i, column).toString() : '0';
                        sum += Number(celVal.replace(',', ''));
                    }
                }

                $('.dynamic-sum-display').html(Number(sum) ? `SUM = ${currency.split(' ')[0]} ${Number(sum).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '');
            } else {
                $('.dynamic-sum-display').html('');
            }
        },

        afterHandsontableCreationMethods: function () {
            this.$('.handsontable table').addClass('comp-tbl-simple');
            this.$container.css('opacity', '1');
            $('.comp-quote-detail-col-headers').addClass('fadeOut');
            this.eventAgg.trigger('updateTotalRowsOnDiscountView', null);
            this.eventAgg.trigger('updateSelectedRowsOnDiscountView', null);
            this.getTablePositionsAndOffsets();
            this.bindEventsToHoT();
            this.resizeContainer();
            this.checkIfFieldsHasToBeDisabled();
            this.isPricingGridLoaded = true;
            if ($('.remove-plugin-filter.remove-filter-all').length) {
                $('.remove-plugin-filter.remove-filter-all').click();
            }

            setTimeout(() => {
                if ([true, 'true'].includes($('#hasConfigureskusIdQuote').val()) || [true, 'true'].includes($('#hasConfigureskusId').val())) {
                    if ($('.mdfyConfig').length > 0) {
                        $('.qut-configurations-tab-link').removeClass('hide');
                    } else {
                        $('.qut-configurations-tab-link').addClass('hide');
                    }
                }
            }, 1000);

            if (this.callOnceForShowingConfigurator) {
                this.showHideConfiguratorColumn(this.hiddenColumnsArray);
                this.callOnceForShowingConfigurator = false;
            }
        },

        deselectRowAndSelectSelected: function (selectedRow) {
            if (selectedRow) {
                console.log(this.selectedVisualRows);
                this.$quoteCartTable.deselectCell();
                this.selectedVisualRows.forEach(item => {
                    if (item != selectedRow[0]) {
                        this.$quoteCartTable.selectRows(item);
                    }
                });
            }

            this.mapPhysicalRowsOfSelectedRows();
        },

        mapPhysicalRowsOfSelectedRows: function () {
            let selectedArrOfArr = this.$quoteCartTable.getSelected() ? this.$quoteCartTable.getSelected() : [];
            this.serviceEnforcementProductArray = {};
            let selectedRowIds = [];
            let selectedVisualArr = [];
            if (selectedArrOfArr.length === 1 && selectedArrOfArr[0][1] === -1) {
                if (selectedArrOfArr[0][0] === -1) {
                    selectedArrOfArr[0][0] = 0;
                }

                if (selectedArrOfArr[0][0] > selectedArrOfArr[0][2]) {
                    let startRowTemp = selectedArrOfArr[0][0];
                    selectedArrOfArr[0][0] = selectedArrOfArr[0][2];
                    selectedArrOfArr[0][2] = startRowTemp;
                }

                for (let i = selectedArrOfArr[0][0]; i <= selectedArrOfArr[0][2]; i++) {
                    let physicalRow = this.$quoteCartTable.toPhysicalRow(i);
                    if (this.isRowSelectable(physicalRow)) {
                        selectedRowIds.push(physicalRow + 1);
                        selectedVisualArr.push(i);
                    }
                }
            } else if (selectedArrOfArr.length && selectedArrOfArr[0][1] === -1) {
                selectedArrOfArr.forEach(item => {
                    if (item[0] != item[2]) {
                        if (item[0] === -1) {
                            item[0] = 0;
                        }

                        if (item[0] > item[2]) {
                            let startRowTemp = item[0];
                            item[0] = item[2];
                            item[2] = startRowTemp;
                        }

                        for (let i = item[0]; i <= item[2]; i++) {
                            let physicalRow = this.$quoteCartTable.toPhysicalRow(i);
                            if (this.isRowSelectable(physicalRow)) {
                                selectedRowIds.push(physicalRow + 1);
                                selectedVisualArr.push(i);
                            }
                        }
                    } else {
                        let physicalRow = this.$quoteCartTable.toPhysicalRow(item[0]);
                        if (this.isRowSelectable(physicalRow)) {
                            selectedRowIds.push(physicalRow + 1);
                            selectedVisualArr.push(item[0]);
                        }
                    }
                });
            }

            if (selectedRowIds.length) {
                this.selectedRowIds = _.uniq(selectedRowIds);
                this.selectedVisualRows = _.uniq(selectedVisualArr);
                this.uncheckDeselect(_.uniq(selectedRowIds), this.jsonTableData);
            } else {
                this.selectedRowIds = [];
                this.selectedVisualRows = [];
                this.uncheckDeselect(_.uniq(selectedRowIds), this.jsonTableData);
            }
        },

        isRowSelectable: function (rowNumber) {
            let rowMeta = this.$quoteCartTable.getCellMeta(rowNumber, this.$quoteCartTable.propToCol('id'));
            let productType = rowMeta.entryType;
            let productLineType = rowMeta.lineType.value;
            let isPositiveCreditLines = false;
            if (rowMeta.isProductDeletionDisabled) {
                return false;
            }

            if (!rowMeta.isParentShipSetEntry && rowMeta.serviceEnforcement) {
                let productID = this.$quoteCartTable.getDataAtCell(this.$quoteCartTable.toVisualRow(rowNumber), this.$quoteCartTable.propToCol('id'));
                this.serviceEnforcementProductArray[productID] = this.$quoteCartTable.getDataAtCell(this.$quoteCartTable.toVisualRow(rowNumber), this.$quoteCartTable.propToCol('partNo'));
            }

            if (isOrderEntrySite && this.deleteZeroValueLineItems.includes(rowNumber + 1)) {
                return true;
            }

            if ($('#hasCreditLine').val() === 'true') {
                isPositiveCreditLines = [this.CREDIT_TYPE, this.EXPANDED_TYPE, this.CONSOLIDATED_TYPE].includes(productLineType) ? true : false;
            }

            if (isOrderEntrySite && this.deleteZeroValueLineItems.includes(rowNumber + 1)) {
                return true;
            }

            if (isOrderEntrySite && productType === 'PER_UNIT_SUBSCRIPTION' && ($('#mitelSubscriptionOrder').val() === true || $('#mitelSubscriptionOrder').val() === 'true')) {
                return false;
            }

            if (!isOrderEntrySite && ($('#mitelSubscriptionOrder').val() === true || $('#mitelSubscriptionOrder').val() === 'true') && $('.qut-header-configurator').hasClass('hidden') && ['SUBSCRIPTION', 'PER_UNIT_SUBSCRIPTION'].includes(productType)) {
                return false;
            }

            if (isPositiveCreditLines && !isOrderEntrySite) {
                return false;
            } else if (this.productSelectableTypes.indexOf(productType) !== -1 || (isOrderEntrySite && ['PER_UNIT_SUBSCRIPTION', 'CONSOLIDATED', 'FULL_TERM_ITEM_CHILD'].includes(productType))) {
                return true;
            } else {
                return false;
            }
        },

        continueDeleteProducts: function () {
            if (_.isEmpty(this.serviceEnforcementProductArray)) {
                this.continueDeleteProductsFromAlert();
                return;
            }

            let productHtml = '';
            $('.delete-sku-products').empty();
            for (let key in this.serviceEnforcementProductArray) {
                productHtml += `
                    <p>${key} &nbsp; ${this.serviceEnforcementProductArray[key]}</p>
                `;
            }

            $('.delete-sku-products').html(productHtml);
            this.eventAgg.trigger('deleteSkuAlert');
        },

        continueDeleteProductsFromAlert: function () {
            /**
            * Just a function
            */
            function compareNumbers(a, b) {
                return a - b;
            }

            let deletingAssociated = true;
            let deleteOnlyBundles = true;
            let model;
            if (this.selectedVisualRows.length === 1 && !this.$quoteCartTable.getDataAtCell(this.selectedVisualRows[0], this.$quoteCartTable.propToCol('id'))) {
                this.$quoteCartTable.alter('remove_row', this.selectedVisualRows[0]);
                this.newjsonData.rows.pop();
                this.uncheckDeselect([], this.jsonTableData);
                this.jsonTableIdMap.pop();
                if ($('.qut-product-invalid-cisco-system').is(':visible')) {
                    $('.qut-product-invalid-cisco-system').html('').hide();
                    this.removeErrorFromCell();
                }

                return;
            }

            if (this.checkIfInvalidRowExistAndRemove()) {
                return;
            }

            this.selectedVisualRows.sort(compareNumbers);
            this.selectedVisualRows.forEach(row => {
                let line = this.newjsonData.rows[this.$quoteCartTable.toPhysicalRow(row)];
                if (line && line.type === this.STANDARD_TYPE) {
                    deleteOnlyBundles = false;
                }

                if (!model) {
                    model = line;
                }
            });

            if (this.selectedRowIds.length === this.newjsonData.rows.length || deleteOnlyBundles) {
                deletingAssociated = false;
            }

            if (model.type === 'VIP' || model.type === 'CONFIGURED_PARENT') {
                deletingAssociated = true;
            }

            if (model.type === 'VPSP' || model.type === 'SCONTP') {
                deletingAssociated = false;
            }

            if (this.selectedRowIds.length) {
                let selectedRowIdMap = this.selectedRowIds.map(item => Number(this.jsonTableIdMap[Number(item - 1)]));

                //Removing ServiceEnforcement Products
                let mappedKeys = Object.keys(this.serviceEnforcementProductArray).map(Number);
                selectedRowIdMap = selectedRowIdMap.filter(id => !mappedKeys.includes(id * 10));
                this.removeRow(selectedRowIdMap, deletingAssociated);
            }
        },

        checkIfInvalidRowExistAndRemove: function (action) {
            let emptyRowNumber = '';
            let hasEmptyRow = this.$quoteCartTable.getDataAtCol(this.$quoteCartTable.propToCol('id')).some((item, index) => {
                if (!item) {
                    emptyRowNumber = index;
                    return true;
                } else {
                    return false;
                }
            });

            if (hasEmptyRow) {
                if (!['filter'].includes(action)) {
                    this.eventAgg.trigger('invalidRowDeleted');
                    this.$quoteCartTable.deselectCell();
                }

                this.$quoteCartTable.alter('remove_row', emptyRowNumber);
                this.newjsonData.rows.pop();
                return true;
            } else {
                return false;
            }
        },

        dragAndDropAPI: function (startRow, endRow) {
            this.quoteTableDrag = new ws.models.quoteTableDrag({
                quoteId: $('#quoteCode').val(),
                startRow: startRow,
                endRow: endRow
            });

            this.quoteTableDrag.save(null, {
                type: 'PUT',
                silent: true
            }).done(function (response) {
                this.eventAgg.trigger('refreshQuoteProductCart', true, false);
                this.eventAgg.trigger('updateSBATab');
            }.bind(this));
        },

        dragAndDropRefresh: function () {
            this.eventAgg.trigger('refreshQuoteProductCart', true, true);
        },

        refreshColumnsOrder: function () {
            let columnSettings = [];
            let totalColumns = this.$quoteCartTable.countCols();

            for (let i = 0; i < totalColumns; i++) {
                columnSettings.push({
                    id: i,
                    name: this.getColPropertyFromHeader(i),
                    width: this.$quoteCartTable.getColWidth(i)
                });
            }

            this.columnsSettingsModel.set('columns', columnSettings);
            this.colMapping = columnSettings;
            this.$quoteCartTable.render();
        },

        togglesReadOnlyColumnsBasedOnShipCompleteAndEndUser: function (flagForEndUser, flagForRequestShip) {
            let requestShipCompleteFlag = flagForRequestShip != undefined ? flagForRequestShip : $('#requestShipComplete').is(':checked');
            let endUserFlag = flagForEndUser ? true : ($('#endUserBilling').prop('checked') ? false : true);
            let sapOrderId = this.sapOrderId;
            let markUpPercentage = typeof this.$quoteCartTable.propToCol('markUpPercentage') === 'number' ? this.$quoteCartTable.propToCol('markUpPercentage') : 100;
            let markUp = typeof this.$quoteCartTable.propToCol('markUp') === 'number' ? this.$quoteCartTable.propToCol('markUp') : 100;
            let delGroup = typeof this.$quoteCartTable.propToCol('delGroup') === 'number' ? this.$quoteCartTable.propToCol('delGroup') : 100;
            let shipDate = typeof this.$quoteCartTable.propToCol('shipDate') === 'number' ? this.$quoteCartTable.propToCol('shipDate') : 100;

            for (let i = 0; i < this.$quoteCartTable.countRows(); i++) {
                let model = this.newjsonData.rows[i];
                if (sapOrderId || (model && this.isToBeDisabledOnChangeOfMarkUpOrShipComplete(model))) {
                    this.$quoteCartTable.setCellMeta(i, markUpPercentage, 'readOnly', true);
                    this.$quoteCartTable.setCellMeta(i, markUp, 'readOnly', true);
                    this.$quoteCartTable.setCellMeta(i, delGroup, 'readOnly', true);
                    this.$quoteCartTable.setCellMeta(i, shipDate, 'readOnly', true);
                } else {
                    this.$quoteCartTable.setCellMeta(i, markUpPercentage, 'readOnly', endUserFlag);
                    this.$quoteCartTable.setCellMeta(i, markUp, 'readOnly', endUserFlag);
                    this.$quoteCartTable.setCellMeta(i, delGroup, 'readOnly', requestShipCompleteFlag);
                    this.$quoteCartTable.setCellMeta(i, shipDate, 'readOnly', requestShipCompleteFlag);
                }
            }
        },

        isToBeDisabledOnChangeOfMarkUpOrShipComplete: function(model) {
            return this.markUpRollUpDisable.indexOf(model.type) !== -1;
        },

        toggleResetButton: function (show) {
            this.$resetColumnsButton.toggle(show);
        },

        checkIfFilterAppliedBeforeAddNewProducts: function () {
            this.filterCheckAction = 'multiple-product';
            if ($('.remove-plugin-filter.remove-filter-all').length) {
                this.eventAgg.trigger('removeFilterToContinueModal');
            } else {
                if ($('.quf-vendor-select option').length === 0) {
                    this.getCopyPasteOptionMap();
                } else {
                    this.addProductOpenModal();
                }
                
            }
        },

        getCopyPasteOptionMap: function () {
            $.ajax({
                url: globals.path.api.quoting.getCopyPasteOptions,
                type: 'GET',
                success: (response) => {
                    if (response) {
                        $('.quf-vendor-select').empty();
                        let options = ``;
                        _.each(response, (value, key) => {
                            options += `<option value='${value}' ${value === 'P' ? 'selected="selected"' : ''}>${globals[key]}</option>`;
                        });

                        $('.quf-vendor-select').append(options);
                        this.addProductOpenModal();
                    }
                },

                fail: function(response) {
                    console.error(response);
                }
            });
        },

        removeAppliedFilters: function () {
            if ($('.remove-plugin-filter.remove-filter-all').length) {
                let filtersPlugin = this.$quoteCartTable.getPlugin('filters');
                filtersPlugin.clearConditions();
                this.filterConditions = {};
                filtersPlugin.filter();
            }

            this.deleteZeroValueButtonDisplay(this.deleteZeroValueLineItems);
        },

        removeFiltersAndContinueAddProducts: function () {
            this.removeAppliedFilters();
            if (this.filterCheckAction === 'multiple-product') {
                this.addProductOpenModal();
            } else {
                this.$quoteCartTable.alter(this.filterCheckAction, this.filterCheckActionIndex);
            }

            $('.qut-remove-filter-to-continue-modal').click();
            this.deleteZeroValueButtonDisplay(this.deleteZeroValueLineItems);
        },

        addRow: function () {
            if ($('#qut-table-3pl').val() === 'true' || this.isQuoteReadOnly || $('.qut-add-row').hasClass('disabled')) {
                return;
            }

            this.$quoteCartTable.alter('insert_row_below');
            this.resizeContainer();
        },

        addProductOpenModal: function(e) {
            if ($('#statusID').val() !== 'ORDER_REQUESTED') {
                this.eventAgg.trigger('qut-openAddProductModal');
            }
        },

        confirmDelete: function () {
            if (!$('.qut-delete-row').hasClass('disabled')) {
                if (this.selectedRowIds && this.selectedRowIds.length > 0 && (!this.isQuoteReadOnly || $('#qut-table-3pl').val() === 'true')) {
                    this.$deleteErrorMessage.addClass('hide').hide();
                    this.eventAgg.trigger(this.deleteModalId);
                }
            }
        },

        findRelatedCell: function (prop, col, row) {
            return (prop.propName === 'cntrtStDate') ? {row: row, col: col + 1} : {row: row, col: col - 1};
        },

        getTablePositionsAndOffsets: function() {
            if (this.$masterContainer) {
                let bodyRect = document.body.getBoundingClientRect();
                let elemRect = this.$masterContainer.offset();

                if (elemRect) {
                    this.tableLeftPostion = elemRect.left - bodyRect.left;
                }
            }
        },

        syncScrollBars: function (e) {
            let offset = $(e.currentTarget).scrollLeft();
            this.$topScrollBar.scrollLeft(offset);
            this.$bottomScrollBar.scrollLeft(offset);
        },

        renderTopScroller: function () {
            this.$topScrollBar.find('div').css('width', this.$bottomScrollBar.find('.wtHider').width() + 'px');
            this.$topScrollBar.scroll(_.debounce(this.syncScrollBars.bind(this), 0, true));
            this.$bottomScrollBar.scroll(_.debounce(this.syncScrollBars.bind(this), 0, true));
        },

        resizeContainer: function () {
            if (this.$quoteCartTable && this.$quoteCartTable !== null && this.$quoteCartTable.table !== null) {
                let containerHeight = 0;
                let rows = this.$quoteCartTable.countRows() > 20 ? 20 : this.$quoteCartTable.countRows();
                let thHeight = parseInt(this.$('.ht_master table thead').height());
                let tableHeaderHeight = thHeight ? thHeight + 34 : 111;
                let rowHeight = 34;
                containerHeight = rows * rowHeight + tableHeaderHeight;
                this.$container.height(containerHeight);
                this.$quoteCartTable.updateSettings({height: containerHeight});
            }

        },

        showHideConfiguratorColumn: function (arr) {
            if (this.shouldShowConfiguratorColumn || $('#claimRFQ').val() === 'true' || ([true, 'true'].includes($('#mitelSubscriptionOrder').val()))) {
                this.$quoteCartTable.updateSettings({
                    hiddenColumns: {
                        columns: this.hiddenColumnsArray
                    }
                });
            } else {
                if (this.hiddenColumnsArray.includes(2)) {
                    let index = this.hiddenColumnsArray.indexOf(2);
                    this.hiddenColumnsArray.splice(index, 1);
                }

                if (this.hiddenColumnsArray.includes(3)) {
                    let index = this.hiddenColumnsArray.indexOf(3);
                    this.hiddenColumnsArray.splice(index, 1);
                }

                this.$quoteCartTable.updateSettings({
                    hiddenColumns: {
                        columns: this.hiddenColumnsArray
                    }
                });
            }

        },

        currencyValidator: function (value, callback) {
            if (value.trim().includes(' ')) {
                callback(false); //user should not enter empty characters
            } else if (isNaN(value)) {
                callback(/^[\s\d,$]+$/.test(value)); //allow $ with spaces to be submitted
            } else {
                callback(true); //if a number, only positive value can be submitted
            }
        },

        simpleNumericValidator: function (value, callback) {
            if (isNaN(value)) {
                callback(false);
            } else {
                callback(true);
            }
        },

        percentValidator: function (value, callback) {
            if (isNaN(value)) {
                callback(/^-?[0-9]{1,9}([\.][0-9]{1,100})?[\s,%]+$/.test(value)); //allow % with spaces to be submitted
            } else {
                callback(true);
            }
        },

        getColNumber: function (prop) {
            var column = _.findWhere(this.colMapping, {name: prop});
            return column ? column.id : '';
        },

        getNewTotals: function (calcFreight, response) {
            if (isOrderEntrySite) {
                this.newTotalsModel.fetch().done(function (data) {
                    this.eventAgg.trigger('quoteTableUpdateTotalsSections', data);
                    if (calcFreight && $('#enableNewFreightLogic').val() === 'true') {
                        $('.calculated-freight').html(calcFreight);
                        if (response && ['ERROR', 'MANUAL'].includes(response.calculatedNewFreight.formattedValue)) {
                            $('.qut-totalFreightCopyWrapper').html('TBD');
                        } else {
                            $('.qut-totalFreightCopyWrapper').html(data.data.totals.totalFreight.formattedValue);
                        }
                    }
                }.bind(this));
            } else {
                if (calcFreight && $('#enableNewFreightLogic').val() === 'true') {
                    $('.calculated-freight').html(calcFreight);
                    if (response && ['ERROR', 'MANUAL'].includes(response.calculatedNewFreight.formattedValue)) {
                        $('.qut-totalFreightCopyWrapper').html('TBD');
                    } else {
                        $('.qut-totalFreightCopyWrapper').html(response.calculatedNewFreight.formattedValue);
                    }
                }
            }
        },

        attr: function (at) {
            let attr = function (model, value) {
                if (!value) {
                    return model && model.get(at);
                }

                model.set(at, value);
            };

            attr.propName = at;
            return attr;
        },

        makeProduct: function () {
            return new ws.models.quoteTableModel();
        },

        cancelAddNewProductInline: function (model) {
            this.$quoteCartTable.render();
            this.$quoteCartTable.selectCell(this.collection.indexOf(model), this.partNoCol);
        },

        scrollToCurrentRowInIE: function () {
            if (window.offset !== this.pageYOffset) {
                window.scrollTo(0, this.pageYOffset);
            }
        },

        ediContractErrorTooltip: function(e) {
            let getidx = $(e.currentTarget).closest('tr').index();
            let modeldata = this.newjsonData.rows[getidx].attributes.ediContractError;
            this.eventAgg.trigger('quoteTableTooltip', {
                follow: e.currentTarget,
                model: modeldata ? modeldata : '',
                template: _.template($(`#ediContractErrorTooltip`).html())
            });
        },

        popShowHideColumnModal: function() {
            this.eventAgg.trigger('dragDropModal', this.colHeaderMapping);
        },

        removePendingClass: function () {
            this.pending = false;
            this.$container.find('table').removeClass('disabled');
            this.$tableSpinner.addClass('fadeOut');
            this.$tableSpinner.find('table').css('opacity', '1');
            this.$totalsSpinner.css('opacity', '0');
            this.$totalsSpinner.addClass('fadeOut');
            this.selectedRows = [];
            this.$(this.selectAllCheckboxClass).prop('checked', false);
            this.$deleteButton.addClass('disabled');
            if (this.$BlockUpdateButton) {
                this.$BlockUpdateButton.addClass('disabled');
            }
        },

        /**
         * Checks if model is a Bundle Parent item
         * @param {Object} model
         */
        isBundleParent: function(model) {
            return this.productExpandableTypes.indexOf(model.get('type')) !== -1;
        },

        /**
         * Checks if model is a Bundle Child item
         * @param {Object} model
         * @returns {boolean}
         */
        isBundleChild: function(model) {
            return this.productChildTypes.indexOf(model.get('type')) !== -1;
        },

        isCellReadOnly: function(model, attr) {
            if (model.manualItemCategory === this.TANGIBLE_PRODUCT_VALUE && ['listPrice', 'purchasePrice', 'purchaseDiscount', 'extendedCost'].includes(attr)) {
                return true;
            }

            if ([this.CREDIT_TYPE, this.EXPANDED_TYPE].includes(model.lineType)) {
                return (this.childTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentChildTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.ciscoReadOnlyCells.indexOf(attr) !== -1) || (this.stdReadOnlyCells.indexOf(attr) !== -1) || (this.stdCrossCellsReadOnlyCells.indexOf(attr) !== -1) || (this.childRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.parentTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.supportChildReadOnlyCells.indexOf(attr) !== -1);
            } else {
                switch (model.type) {
                    case this.TOPDOWN_PARENT_BUNDLE_TYPE:
                        return this.parentTopDownReadOnlyCells.indexOf(attr) !== -1;
                    case this.ROLLUP_PARENT_BUNDLE_TYPE:
                        return this.parentRollUpReadOnlyCells.indexOf(attr) !== -1;
                    case this.TOPDOWN_CHILD_BUNDLE_TYPE:
                        return this.childTopDownReadOnlyCells.indexOf(attr) !== -1;
                    case this.CISCO_CHILD_BUNDLE_TYPE:
                        return this.ciscoReadOnlyCells.indexOf(attr) !== -1;
                    case this.CISCO_PARENT_BUNDLE_TYPE:
                        return this.ciscoReadOnlyCells.indexOf(attr) !== -1;
                    case this.ROLLUP_CHILD_BUNDLE_TYPE:
                        return this.childRollUpReadOnlyCells.indexOf(attr) !== -1;
                    case this.AVAYA_CLOULD_TYPE:
                        return this.avayaCloudReadOnlyCells.indexOf(attr) !== -1;
                    case 'VIC':
                        return this.stdReadOnlyCells.indexOf(attr) !== -1;
                    case 'VIP':
                        return this.stdReadOnlyCells.indexOf(attr) !== -1;
                    case 'SCONTP':
                        return this.supportLineParent.indexOf(attr) !== -1 && isQuotingSite;
                    case this.BLUE_SKY_TYPE:
                        return (this.blueSkyReadOnlyCells.indexOf(attr) !== -1 || this.tecexReadOnlyCells.indexOf(attr) !== -1 || this.childTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentChildTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.ciscoReadOnlyCells.indexOf(attr) !== -1) || (this.stdReadOnlyCells.indexOf(attr) !== -1) || (this.stdCrossCellsReadOnlyCells.indexOf(attr) !== -1) || (this.childRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.parentTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.supportChildReadOnlyCells.indexOf(attr) !== -1);
                    case this.BLUE_SKY_PARENT_TYPE:
                        return (this.blueSkyReadOnlyCells.indexOf(attr) !== -1 || this.tecexReadOnlyCells.indexOf(attr) !== -1 || this.childTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentChildTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.ciscoReadOnlyCells.indexOf(attr) !== -1) || (this.stdReadOnlyCells.indexOf(attr) !== -1) || (this.stdCrossCellsReadOnlyCells.indexOf(attr) !== -1) || (this.childRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.parentTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.supportChildReadOnlyCells.indexOf(attr) !== -1);
                    case this.BLUE_SKY_CHILD_TYPE:
                        return (this.configuratorChildReadOnlyCells.indexOf(attr) !== -1 || this.blueSkyReadOnlyCells.indexOf(attr) !== -1 || this.tecexReadOnlyCells.indexOf(attr) !== -1 || this.childTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentChildTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.ciscoReadOnlyCells.indexOf(attr) !== -1) || (this.stdReadOnlyCells.indexOf(attr) !== -1) || (this.stdCrossCellsReadOnlyCells.indexOf(attr) !== -1) || (this.childRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.parentTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.supportChildReadOnlyCells.indexOf(attr) !== -1);
                    case 'SCONTC':
                        return (this.childTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.ciscoReadOnlyCells.indexOf(attr) !== -1) || (this.stdReadOnlyCells.indexOf(attr) !== -1) || (this.stdCrossCellsReadOnlyCells.indexOf(attr) !== -1) || (this.childRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.parentTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.supportChildReadOnlyCells.indexOf(attr) !== -1);
                    case 'PER_UNIT_SUBSCRIPTION':
                        if (isQuotingSite) {
                            return (this.childTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.ciscoReadOnlyCells.indexOf(attr) !== -1) || (this.stdReadOnlyCells.indexOf(attr) !== -1) || (this.stdCrossCellsReadOnlyCells.indexOf(attr) !== -1) || (this.childRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.parentChildTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentChildRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.supportChildReadOnlyCells.indexOf(attr) !== -1);
                        } else {
                            return this.avayaChildReadOnlyCells.indexOf(attr) !== -1;
                        }

                        break;
                    case 'FULL_TERM_ITEM_CHILD':
                        if (isQuotingSite) {
                            return (this.childTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.ciscoReadOnlyCells.indexOf(attr) !== -1) || (this.stdReadOnlyCells.indexOf(attr) !== -1) || (this.stdCrossCellsReadOnlyCells.indexOf(attr) !== -1) || (this.childRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.parentChildTopDownReadOnlyCells.indexOf(attr) !== -1) || (this.parentChildRollUpReadOnlyCells.indexOf(attr) !== -1) || (this.supportChildReadOnlyCells.indexOf(attr) !== -1);
                        } else {
                            return this.ciscoReadOnlyCells.indexOf(attr) !== -1;
                        }

                        break;
                    case 'FULL_TERM_ITEM_PARENT':
                        return this.ciscoReadOnlyCells.indexOf(attr) !== -1;
                    case 'FULL_TERM_ITEM':
                        return this.ciscoReadOnlyCells.indexOf(attr) !== -1;
                    case 'TECEX':
                        return this.tecexReadOnlyCells.indexOf(attr) !== -1;
                    case this.STANDARD_TYPE:
                        if (model.mandatoryAttach) {
                            return this.stdCrossCellsReadOnlyCells.indexOf(attr) !== -1;
                        } else {
                            return this.stdReadOnlyCells.indexOf(attr) !== -1;
                        }
                }
            }
        },

        setCellReadOnlyClass: function(element, isReadOnly) {
            if (isReadOnly) {
                element.className = element.className + ' ' + this.CELL_READ_ONLY_CLASS;
            }
        },

        openBulkUpdatePricingModal: function (e, coords) {
            let colHeader = $(e.target).data('colnum');
            $('.pricing-bulk-update-input label').text(colHeader);
            this.selectedHeader =  this.$quoteCartTable.colToProp(coords.col);
            $('#pricing-bulk-update-modal .error-message').html('');
            $('.pricing-bulk-update-input').addClass('hidden');
            if (this.selectedHeader === 'cntrtStartDate' || this.selectedHeader === 'cntrtEndDate') {
                $('#pricingUpdateDate').removeClass('hidden');
            } else {
                $('#pricingUpdateText').removeClass('hidden');
            }

            $('.pricingBulkUpdateDropdown').pikaday('gotoToday');
            $('#pricingBulkUpdateValue').val('');
            $('.pricingBulkUpdateDropdown').val('');
            $('.apply-pricingBulk').addClass('disabled');
            if (this.selectedHeader === 'notes') {
                $('.notesSection').removeClass('hide');
                $('.otherThanNotesSection').addClass('hide');
                $('.qut-table-comment-text-bulk').removeClass('hidden');
            } else {
                $('.notesSection').addClass('hide');
                $('.otherThanNotesSection').removeClass('hide');
                $('.qut-table-comment-text-bulk').addClass('hidden');
            }

            this.eventAgg.trigger('pricing-bulk-update-modal');
        },

        pricingBulkUpdateModalChangee: function () {
            let updatedValue = $('.pricing-bulk-update-input').not('.hidden').find('#pricingBulkUpdateValue').val();
            let notesVal =  $('.qut-table-comment-text-bulk').val();
            let poTextVal =  $('.qut-table-purchaseOrder-text-bulk').val();
            let inputRadioTextVal =  $('input[name="qut-comments-radio-bulk"]').val();
            if (updatedValue || notesVal || inputRadioTextVal || poTextVal) {
                $('.apply-pricingBulk').removeClass('disabled');
            } else if (!$('.apply-pricingBulk').hasClass('disabled')) {
                $('.apply-pricingBulk').addClass('disabled');
            }
        },

        notesDragHandle: function (changes) {
            let selectedCell = this.$quoteCartTable.getSelected();
            let originalCellObject = this.newjsonData.rows[this.$quoteCartTable.toPhysicalRow(selectedCell[0][0])].notes;
            let entryNumbers = [];
            changes.forEach(row => {
                entryNumbers.push(row[0] + 1);
            });

            let commentData = {
                note: originalCellObject.note,
                showNote: originalCellObject.showNote,
                poText: originalCellObject.poText,
                row: entryNumbers
            };

            this.updateComments(commentData, 'true');
        },

        bulkUpdateValueToCells: function (e) {
            this.addPendingClass();
            let userValue = $('.pricing-bulk-update-input').not('.hidden').find('#pricingBulkUpdateValue').val();
            this.$quoteCartTable.selectColumns(this.selectedHeader);
            let selected = this.$quoteCartTable.getSelected();
            if (this.selectedHeader === 'notes') {
                let entryNumbers = [];
                for (let i = 0; i <= selected[0][2]; i++) {
                    entryNumbers.push(this.$quoteCartTable.toPhysicalRow(i) + 1);
                }

                let commentData = {
                    note: $('.qut-table-comment-text-bulk').val(),
                    showNote: $('input[name="qut-comments-radio-bulk"]:checked').val() === 'true' ? true : false,
                    poText: $('.qut-table-purchaseOrder-text-bulk').val(),
                    row: entryNumbers
                };

                this.updateComments(commentData, 'true');
                $('.cancel-pricingBulk').trigger('click');
            } else {
                if (selected.length) {
                    this.performBulkUpdate(this.selectedHeader, userValue);
                    $('.cancel-pricingBulk').trigger('click');
                }
            }
        },

        performBulkUpdate: function (column, value) {
            let isCopyUpdate = ['cntrtStartDate', 'cntrtEndDate'].includes(column) || isOrderEntrySite;
            let tableObj = this.newjsonData.rows;
            const updates = [];
            if (isCopyUpdate) {
                for (let row = 0; row < tableObj.length; row++) {
                    let cellObj = tableObj[row][column];
                    if (!cellObj.disabled) {
                        updates.push([row, this.$quoteCartTable.propToCol(column), value]);
                    }
                }
            } else {
                let entriesObj = this.$quoteCartTable.getData();
                let entries = entriesObj.map((item) => {
                    return (Number(item[0]) / 10) - 1;
                });

                for (let rowNum = 0; rowNum < tableObj.length; rowNum++) {
                    let cellObj = tableObj[rowNum][column];
                    if (!cellObj.disabled && entries.includes(rowNum)) {
                        updates.push(rowNum + 1);
                    }
                }
            }

            if (updates.length === 0) {
                this.removePendingClass();
            } else {
                if (isCopyUpdate) {
                    this.$quoteCartTable.setDataAtRowProp(updates, 'bulk');
                } else {
                    let url = globals.path.api.quoting.quoteTableUpdateProduct.replace('{quoteId}', this.$quoteNumber) + '?' + CSRF;
                    let request = {
                        editedCol: column,
                        currencyConversion: true,
                        editedValue: value,
                        entryNumbers: updates
                    };

                    this.eventAgg.trigger('makeUpdateCallOnChange', request, url, column);
                }
            }
        },

        addErrorToCell: function (cell) {
            var currentCell = cell ? cell : {row: this.editedRow, col: this.editedCol};
            this.$quoteCartTable.getCellMeta(currentCell.row, currentCell.col).valid = false;
            var isErrorCell = _.where(this.errorCells, currentCell).length > 0;
            if (!isErrorCell) {
                this.errorCells.push(currentCell);
            }

            this.checkTableErrors();
        },

        removeErrorFromCell: function (cell, includeDates) {
            this.invalidChange = false;
            cell = cell ? cell : {row: this.editedRow, col: this.editedCol};
            let remainingErrorCells = this.errorCells.filter(cell => {
                if ([this.$quoteCartTable.propToCol('cntrtStartDate'), this.$quoteCartTable.propToCol('cntrtEndDate')].includes(cell.col) && !includeDates) {
                    return cell;
                } else {
                    this.$quoteCartTable.getCellMeta(cell.row, cell.col).valid = true;
                }
            });

            this.errorCells = remainingErrorCells;
            this.checkTableErrors();
        },

        addPendingClass: function () {
            if (!$('.comp-quote-detail-table').find('table').hasClass('disabled')) {
                this.$container.find('table').addClass('disabled');
                this.pending = true;
                this.$totalsSpinner.removeClass('fadeOut');
                this.$tableSpinner.removeClass('fadeOut');
                this.$tableSpinner.find('table').css('opacity', '0');
            }
        },

        addPendingClassToRow: function (updatedRow) {
            this.pending = true;
            this.$quoteCartTable.updateSettings({
                cells: function setPropertiesForCell(row) {
                    var cellProperties = {};
                    if (row === updatedRow) {
                        cellProperties.readOnly = true;
                        cellProperties.renderer = function (notUsed, td) {
                            td.style.fontStyle = 'italic';
                            td.style.color = '#ccc';
                            td.style.backgroundColor = '#aaa';
                        };
                    }

                    return cellProperties;
                }
            });
        },

        getSBASelectedRows: function () {
            let selectedSBAData = [];
            if (this.$quoteCartTable && this.$quoteCartTable !== null) {
                let selectedRows = this.selectedRowIds;
                if (selectedRows && selectedRows.length) {
                    for (let i = 0; i < selectedRows.length; i++) {
                        let rowData = this.newjsonData.rows[selectedRows[i] - 1];
                        if (!['VPSP', 'VPSC', 'FULL_TERM_ITEM'].includes(rowData.type) && !this.subscriptionTypes.includes(rowData.type) && !this.blueSkyTypes.includes(rowData.type) && !this.annuityTypesCheckbox.includes(rowData.type) && !this.parentBundleTypes.includes(rowData.type)) {
                            let physicalRowData = {
                                id: selectedRows[i],
                                partNumber:  this.$quoteCartTable.getDataAtCell(this.$quoteCartTable.toVisualRow(selectedRows[i] - 1), this.$quoteCartTable.propToCol('partNo'))
                            };

                            selectedSBAData.push(physicalRowData);
                        }
                    }

                    this.eventAgg.trigger('getSbaDataFromPricingGrid', selectedSBAData);
                } else {
                    let numberOfRows = this.$quoteCartTable.countRows();
                    for (let i = 0; i < numberOfRows; i++) {
                        let rowData = this.newjsonData.rows[this.$quoteCartTable.toPhysicalRow(i)];
                        if (!['VPSP', 'VPSC', 'FULL_TERM_ITEM'].includes(rowData.type) && !this.subscriptionTypes.includes(rowData.type) && !this.blueSkyTypes.includes(rowData.type) && !this.annuityTypesCheckbox.includes(rowData.type) && !this.parentBundleTypes.includes(rowData.type)) {
                            let physicalRowData = {
                                id: this.$quoteCartTable.toPhysicalRow(i) + 1,
                                partNumber:  this.$quoteCartTable.getDataAtCell(i, this.$quoteCartTable.propToCol('partNo'))
                            };

                            selectedSBAData.push(physicalRowData);
                        }
                    }

                    this.eventAgg.trigger('getSbaDataFromPricingGrid', selectedSBAData);
                }
            }
        },

        getSelectedRowsToApplySBAfromPricingGrid: function (ev) {
            if (this.selectedRowIds.length) {
                this.eventAgg.trigger('getSelectedRowsToApplySBAs', this.selectedRowIds);
            }
        },

        createBundleIconElement: function(parentElement, modelId, iconClass, isVRF) {
            var spanBundle = document.createElement('span');
            spanBundle.className = isVRF ? iconClass : 'qut-expand-icon ' + iconClass;
            spanBundle.setAttribute('data-id', modelId);
            parentElement.appendChild(spanBundle);
        },

        expandFullScreen: function() {
            if ($('.qut-detail-table-row').is(':visible')) {
                if ($('.qut-detail-table-row').hasClass('full-screen-enabled')) {
                    $('.qut-detail-table-row').removeClass('full-screen-enabled');
                    $('.exp-pg-btn').removeClass('collapse-pg-btn');
                    $('.icon-exp-pg-btn').removeClass('icon-collapse-pg-btn');
                    $('body').removeClass('no-scroll-body');
                    $('.hed-comp-header-right').show();
                    $('.exp-pg-tooltip').html('Expand Pricing Grid');
                    $('.exp-pg-tooltip').removeClass('exp-pg-tooltip-etc');
                    $(window).scrollTop(0);
                    this.$quoteCartTable.render();
                    $('.htDropdownMenu').hide();
                    $('.modal-container:visible').find('.close-button').trigger('click');
                } else {
                    $('.qut-detail-table-row').addClass('full-screen-enabled');
                    $('.exp-pg-btn').addClass('collapse-pg-btn');
                    $('.icon-exp-pg-btn').addClass('icon-collapse-pg-btn');
                    $('.exp-pg-tooltip').html('Collapse Pricing Grid');
                    $('.hed-comp-header-right').hide();
                    $('.exp-pg-tooltip').addClass('exp-pg-tooltip-etc');
                    $('body').addClass('no-scroll-body');
                    setTimeout(function() {
                        $(window).scrollTop(0);
                    }, 1000);

                    this.$quoteCartTable.render();
                    $('.htDropdownMenu').hide();
                    $('.modal-container:visible').find('.close-button').trigger('click');
                }
            }
        },

        triggerMitelConfigurator: function (e) {
            e.preventDefault();
            this.isIframeTriggered = true;
            let endUser = $('#endUserUid').val() || $('#end-user-account').val();
            let salesOrg = $('#sales-org-input').val() || $('.salesOrg').val();
            if (!$('#subscriptionParent').val()) {
                this.eventAgg.trigger('showDenodoEmptyWarningModal');
                return;
            }

            if (endUser) {
                let getDenodoUrl = globals.path.api.quoting.getDenodoId.replace('{quoteId}', $('#quoteCode').val()) + '?subscriptionProduct=' + $('#subscriptionParent').val() + '&' + 'salesOrg=' + salesOrg + '&' + CSRF;
                $.ajax({
                    url: getDenodoUrl,
                    contentType: 'application/json',
                    method: 'POST'
                }).done(function (response) {
                    if (response && response.length) {
                        this.getPartnerKeyAndTriggerIframe(endUser, salesOrg, response);
                    } else {
                        this.eventAgg.trigger('showDenodoEmptyWarningModal');
                    }
                }.bind(this)).fail(function (e) {
                    console.log('error', e);
                });
            } else {
                this.eventAgg.trigger('qut-end-user-mandatory');
            }
        },

        getPartnerKeyAndTriggerIframe: function (endUser, salesOrg, subscriptionParent) {
            this.getPartnerKey = new ws.models.getPartnerKey({
                quoteId: $('#quoteCode').val(),
                salesOrg: salesOrg
            });

            globals.disableApp();
            this.getPartnerKey.save().done(function (response) {
                globals.enableApp();
                if (response) {
                    this.eventAgg.trigger('configuratorModal', subscriptionParent, false, response, salesOrg, endUser, $('[name=sba-resellerAccount]').val(), $('#vendorId').val(), $('.dealID').val());
                } else {
                    this.eventAgg.trigger('tokenNotGenerated');
                }
            }.bind(this)).fail(function() {
                globals.enableApp();
            }.bind(this));
        }
    });
})(westcon);
